import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import { toast } from "react-toastify";

// Api's
import {
  getAllCategoryCombinationsReceivables,
  createNewEclScenarioReceivable,
  getOneReceivableECLScenario,
  updateReceivablesECLScenario,
  deleteReceivableECLScenario,
  getAllReceivableECLScenario,
} from "../../../../Bookclosure/Services/ApiHandler";

import CompanyEditSideMenu from "../CompanyEditSideMenu";
import Breadcrumb from "../../../components/Breadcrumb";

import eclCss from "../../../css/createReceviablesScenarioEcl.module.css";
import commoncss from "../../../css/common.module.css";

import { DragDropContext } from "react-beautiful-dnd";

import { ReactComponent as QuestionMartInfo } from "../../../../myfin_v2/assets/icons/questionECL.svg";
import { ReactComponent as PervBtnIcon } from "../../../../myfin_v2/assets/icons/pervECLBtnIcon.svg";
import { ReactComponent as BreadCrumbsdor } from "../../../../myfin_v2/assets/icons/breadCrumbsDot.svg";
import { ReactComponent as NumUpArrow } from "../../../../myfin_v2/assets/icons/numberIncreaseUp.svg";
import { ReactComponent as NumDownArrow } from "../../../../myfin_v2/assets/icons/numberIncreaseDown.svg";
import { ReactComponent as PercebtageIcn } from "../../../../myfin_v2/assets/icons/eclPercentageIcon.svg";
import { ReactComponent as EclExcaclamater } from "../../../../myfin_v2/assets/icons/eclExcaclamater.svg";
import { ReactComponent as CompleteECLIcon } from "../../../../myfin_v2/assets/icons/completeECL.svg";
import { ReactComponent as ActiveRadioBtn } from "../../../../myfin_v2/assets/icons/activeRadioBtn.svg";
import { ReactComponent as InactiveRadioBtn } from "../../../../myfin_v2/assets/icons/inactiveRadioBtn.svg";
import { ReactComponent as GrayAddIcon } from "../../../../myfin_v2/assets/icons/grayAddIcon.svg";
import { ReactComponent as QuestionMartInfoyellow } from "../../../assets/icons/infoy.svg";

const CreateReceviablesEclScenario = () => {
  const { companyId, id } = useParams();
  const { eclId: scenarioId } = useParams();
  const [companyID, setCompanyID] = useState(companyId);
  const [receviablesID, setreceviablesID] = useState(id);
  const [periodValues, setPeriodValues] = useState([]);

  const location = useLocation();
    const [createOrupdate, setcreateOrupdate] = useState(
      scenarioId ? "updateFlow" : "createFlow"
  );
    
  const handlePeriodChange = (index, value) => {
    const updated = [...periodValues];
    updated[index] = Number(value);
    setPeriodValues(updated);
  };

  // active stage
  const [ActiveStage, setActiveStage] = useState(1);

  // ====================================================================
  // Start Stage One
  const [StageOneScenarioName, setStageOneScenarioName] = useState();
  const [StageOneScenarioApproach, setStageOneScenarioApproach] =
    useState("simplifiedApproach");
  const [stageOneOptions, setStageOneOptions] = useState([]);
  const [stageOneScenarioId, setstageOneScenarioId] = useState("");

  // In Document 5, around line 126
  const fetchScenarios = () => {
    getAllReceivableECLScenario(companyID).then((Response) => {
      console.log(
        "Fetched scenarios:",
        Response.data.receivableECLScenarioList
      ); // ADD THIS
      let listOfScenarios = Response.data.receivableECLScenarioList;
      const formattedOptions = listOfScenarios.map((eachItem) => ({
        value: eachItem._id,
        label: eachItem.name,
      }));
      console.log("Formatted options:", formattedOptions); // ADD THIS
      setStageOneOptions(formattedOptions);
    });
  };
  // End Stage One
  // ====================================================================

  // ====================================================================
  // Start Stage Two
  const [StageTwoScenarioModel, setStageTwoScenarioModel] =
    useState("Provision Matrix");
  const [StageTwoCategorization, setStageTwoCategorization] = useState("No");
  const [StageTwoDefineDefault, setStageTwoDefineDefault] = useState();
  const [interCompanyBalances, setInterCompanyBalances] = useState("No");
  const [StageTwoPDCalculation, setStageTwoPDCalculation] = useState("yearly");
  const [StageTwoNumberOfPeriods, setStageTwoNumberOfPeriods] = useState(10);
  const [StageTwoSAWApE, setStageTwoSAWApE] = useState("weightedAverage");
  const [StageTwoPercentage, setStageTwoPercentage] = useState(2.3);

  const [StageTwoFinalBucket, setStageTwoFinalBucket] = useState();

  const stageTwoOptions = [
    { value: "Provision Matrix", label: "Provision Matrix" },
  ];

  const stageTwoOptionsAddOrMulti = [
    { value: "multiply", label: "Multiply by" },
    { value: "add", label: "Add" },
  ];

  const stageTwoMin = 1;
  const stageTwoMax = 100;
  const stageTwoPercentage =
    ((StageTwoNumberOfPeriods - stageTwoMin) / (stageTwoMax - stageTwoMin)) *
    100;

  // new

  const [DefineAgingBuckets, setDefineAgingBuckets] = useState(false);

  const handleToggle = () => {
    setDefineAgingBuckets(!DefineAgingBuckets);
  };

  const [bucketsLst, setbucketsLst] = useState([
    {from:"0", to: "" }
  ]);

 const handleInputChange = (index, key, value) => {
  const updated = [...bucketsLst];
  updated[index][key] = value;
  
  if (index === 0) {
    updated[index]["name"] = value ? `0-${value}` : "";
  } else {
    updated[index]["name"] =
      updated[index]["from"] && updated[index]["to"]
        ? updated[index]["from"] + "-" + updated[index]["to"]
        : "";
  }
  
  if (key === "to" && value && updated[index + 1]) {
    updated[index + 1]["from"] = String(Number(value) + 1);
   
    if (updated[index + 1]["to"]) {
      updated[index + 1]["name"] = `${Number(value) + 1}-${updated[index + 1]["to"]}`;
    }
  }
  
  if (key === "to" && value && index === updated.length - 1) {
    setStageTwoFinalBucket(Number(value) + 1);
  }
  
  setbucketsLst(updated);
};

useEffect(() => {
  if (StageTwoCategorization === "No" && bucketsLst.length > 0) {
    const lastBucket = bucketsLst[bucketsLst.length - 1];

    if (lastBucket?.to) {
      setStageTwoFinalBucket(String(Number(lastBucket.to) + 1));
    }
  }
}, [bucketsLst, StageTwoCategorization]);


  const handleAddBucket = () => {
  setbucketsLst((prev) => {
    const last = prev[prev.length - 1];

    if (!last?.to) return prev;

    return [
      ...prev,
      {
        from: String(Number(last.to) + 1),
        to: ""
      }
    ];
  });
};

  const handleRemove = (index) => {
    const updated = bucketsLst.filter((_, i) => i !== index);
    setbucketsLst(updated);
  };



const handleCategoryBucketToChange = (key, index, value) => {
  if (!/^\d*$/.test(value)) return;

  setcategorysPDObj((prev) => {
    const old = prev[key];
    const buckets = [...old.values.buckets];

    buckets[index] = {
      ...buckets[index],
      to: value,
      from: index === 0 ? "0" : buckets[index].from,
      name:
        index === 0
          ? `0-${value}`
          : buckets[index].from && value
          ? `${buckets[index].from}-${value}`
          : "",
    };

    if (value && buckets[index + 1]) {
      buckets[index + 1].from = String(Number(value) + 1);
    }
    
    const finalBucketTo = getCategoryFinalBucket(buckets);
    return {
      ...prev,
      [key]: {
        ...old,
        values: {
          ...old.values,
          buckets,
          StageTwoFinalBucketTo: finalBucketTo,
        },
      },
    };
  });
};

const handleAddCategoryBucket = (key) => {


  setcategorysPDObj((prev) => {
    const old = prev[key];
    const buckets = [...old.values.buckets];
    const last = buckets[buckets.length - 1];

    if (!last?.to) return prev;

    buckets.push({
      from: String(Number(last.to) + 1),
      to: "",
    });

    return {
      ...prev,
      [key]: {
        ...old,
        values: {
          ...old.values,
          buckets,
        },
      },
    };
  });
};

const getCategoryFinalBucket = (buckets) => {
  const last = buckets[buckets.length - 1];
  return last?.to ? Number(last.to) + 1 : "";
};

  const [StageTwoFactor, setStageTwoFactor] = useState({
    method: "multiply",
    percentage: "",
    remarks: "",
  });

  const [considerNetCreditCustomer, setconsiderNetCreditCustomer] =
    useState("No");
  const [specificAccountexclusions, setspecificAccountexclusions] =
    useState("Yes");
  const [addFutuerFactor, setaddFutuerFactor] = useState("Yes");

  const [remarks, setremarks] = useState("");

  // End Stage Two
  // ====================================================================

  // ====================================================================
  // Start StageTwo Catgeory
  const [StageTwoActiveCategory, setStageTwoActiveCategory] = useState(0);
  const [StageTwoCategoryScenarioModel, setStageTwoCategoryScenarioModel] =
    useState("PDV");
  const [StageTwoCategoryCategorization, setStageTwoCategoryCategorization] =
    useState("Yes");

  // End StageTwo Catgeory
  // ====================================================================

  const optionsMultiplePDPercentage = [
    { value: "multiply", label: "Multiply by" },
    { value: "add", label: "Add" },
  ];

  const StageTwoOptions = [
  { value: "Provision Matrix", label: "Provision Matrix" },
];

  // const StageTwoCategoryoptions = [
  //   { value: "Vintage Model", label: "PD - Vintage Model" },
  // ];
  // End StageTwo Catgeory
  // ====================================================================

  // ++++++++++++++++++++++++++++++++++++++++++++++++
  // pre filling the categorztion data

  const [categorysData, setcategorysData] = useState([]);

  const [categorysPDObj, setcategorysPDObj] = useState({});

  const getPeriodLabel = (frequency) => {
    switch (frequency) {
      case "yearly":
        return "years";
      case "quarterly":
        return "quarters";
      case "monthly":
        return "months";
      default:
        return "years";
    }
  };

  useEffect(() => {
    // creating object with default values for categorzation, object key is category and sub category both combined.
    getAllCategoryCombinationsReceivables(companyID).then((response) => {
      setcategorysData(response.data.categoryCombinations);

      const CategorysList = response.data.categoryCombinations;

      let pdObj = {};

      if (CategorysList.length > 0) {
        // Deafault values for category inputs
        for (let index = 0; index < CategorysList.length; index++) {
          // console.log('index == ', index);

          let objPD = { ...CategorysList[index] };

          objPD["values"] = {
            excludeFromComputation: "No",
            defaultDays: 10,
            // StageTwoIncludeUndrawnCommitments:'Yes',
            buckets: [
              {from:"0", to: "" },
            ],
            StageTwoFinalBucketTo: "",
            frequency: "monthly",
            computationPercentage: 2,
            netCreditCustomers: "No",
            specificAccountExclusions: "No",
            addFurtherFactor: "Yes",
            StageTwoCategoryNumberOfPeriods: 10,
            // StageTwoCategoryScenarioModel: '',
            // netCreditCustomers :'Yes',
            // specificAccountExclusions : 'No',
            StageTwoCategorySAWApE: "simpleAverage",
            StageTwoFactor: {
              method: "multiply",
              percentage: "20",
              remarks: "",
            },
            min: 1,
            max: 100,
            percentage: 10,
          };

          const key = `${objPD.categoryID}_${objPD.subcategoryID}`;
          pdObj[key] = objPD;
        }
      } else {
        updateDefaultValues();
      }

      // Single updates after loop
      setcategorysPDObj(pdObj);
    });
  }, [companyID]);

  const [hasInitialized, setHasInitialized] = useState(false);

    useEffect(() => {
      if (
        createOrupdate === "updateFlow" &&
        Object.keys(categorysPDObj).length > 0 &&
        !hasInitialized
      ) {
        updateDefaultValues(); 
        setHasInitialized(true);
      }
    }, [categorysPDObj, createOrupdate, hasInitialized]);
      
  useEffect(() => {
    // Whenever user changes number of periods → refill defaults
    setPeriodValues(
      Array(StageTwoNumberOfPeriods).fill(StageTwoNumberOfPeriods)
    );
  }, [StageTwoNumberOfPeriods]);

  // End Category all stages data and send to api
  // ++++++++++++++++++++++++++++++++++++++++++++++++

  // ++++++++++++++++++++++++++++++++++++++++++++++++
  //  store all stages data
  const [stageOneWholeData, setstageOneWholeData] = useState({
    name: StageOneScenarioName,
    provisioningApproach: StageOneScenarioApproach,
  });

  useEffect(() => {
    setstageOneWholeData({
      name: StageOneScenarioName,
      provisioningApproach: StageOneScenarioApproach,
    });
  }, [
    // when any states get update new data update in to stage two whole data
    StageOneScenarioName,
    StageOneScenarioApproach,
  ]);

  // creating default object with value's
  const [stageTwoWholeData, setstageTwoWholeData] = useState({
    model: StageTwoScenarioModel,
    categorize: StageTwoCategorization,
    global: {
      defaultDays: StageTwoDefineDefault,
      bucketOneNotDue: DefineAgingBuckets === true ? "Yes" : "No",
      periods: StageTwoNumberOfPeriods,
      buckets: [],
      StageTwoFinalBucket: StageTwoFinalBucket,
      frequency: StageTwoPDCalculation,
      computationMethod: StageTwoSAWApE,
      computationPercentage: StageTwoPercentage,
      netCreditCustomers: considerNetCreditCustomer,
      specificAccountExclusions: specificAccountexclusions,
      addFurtherFactor: addFutuerFactor,
      additionalFactor: {
        method: StageTwoFactor.method,
        percentage: StageTwoFactor.percentage,
        remarks: remarks,
      },
    },
  });

const buildGlobalBuckets = () => {
  return bucketsLst
    .filter(b => b.to !== "")
    .map((b, index) => ({
      name: index === 0 ? `0-${b.to}` : `${b.from}-${b.to}`,
      from: Number(b.from),
      to: Number(b.to),
    }));
};

  // UPDATE Section when any state update keep updating into whole data this are going to send data to api
  // update stage two whole data
  useEffect(() => {
    setstageTwoWholeData({
      model: StageTwoScenarioModel,
      categorize: StageTwoCategorization,
      global: {
        defaultDays: StageTwoDefineDefault,
        bucketOneNotDue: DefineAgingBuckets === true ? "Yes" : "No",
        buckets: buildGlobalBuckets(),
        StageTwoFinalBucket: StageTwoFinalBucket,
        periods: StageTwoNumberOfPeriods,
        frequency: StageTwoPDCalculation,
        computationMethod: StageTwoSAWApE,
        computationPercentage: StageTwoPercentage,
        netCreditCustomers: considerNetCreditCustomer,
        specificAccountExclusions: specificAccountexclusions,
        addFurtherFactor: addFutuerFactor,
        additionalFactor: {
          method: StageTwoFactor.method,
          percentage: StageTwoFactor.percentage,
          remarks: remarks,
        },
      },
    });
  }, [
    // when any states get update new data update in to stage two whole data
    StageTwoScenarioModel,
    StageTwoCategorization,
    StageTwoDefineDefault,
    DefineAgingBuckets,
    bucketsLst,
    StageTwoFinalBucket,
    StageTwoNumberOfPeriods,
    StageTwoPDCalculation, // frequence Value
    StageTwoSAWApE,
    StageTwoPercentage,
    considerNetCreditCustomer,
    specificAccountexclusions,
    addFutuerFactor,
    StageTwoFactor,
    remarks,
  ]);

  const [stageTwoCategoryWholeData, setstageTwoCategoryWholeData] =
    useState(categorysPDObj);

  useEffect(() => {
    setstageTwoCategoryWholeData(categorysPDObj);
  }, [categorysPDObj]);

  // Update flow prefilling the data
  // const updateDefaultValues = () => {
  //   if (createOrupdate === "updateFlow") {
  //     getOneReceivableECLScenario(scenarioId)
  //       .then((response) => {
  //         let senarioData = response.data.receivableECLScenario;

  //         // stage One Data Pre fill
  //         setStageOneScenarioName(senarioData.name);
  //         setStageOneScenarioApproach(senarioData.provisioningApproach);

  //         let senarioPDdata = senarioData;

  //         if (senarioPDdata.categorize === "Yes") {
  //           setStageTwoCategorization("Yes");

  //           // merge in place
  //           for (let i = 0; i < senarioData.categorized.length; i++) {
  //             const entry = senarioData.categorized[i];
  //             const key = entry.categoryID + "_" + entry.subcategoryID;
  //             if (categorysPDObj[key] && entry.values) {
  //               let bucketsentryLst = entry.values.buckets;
  //               // const onlyFromBucket = bucketsentryLst.find(bucket => !("to" in bucket));

  //               const index = bucketsentryLst.findIndex(
  //                 (bucket) => !("to" in bucket)
  //               );
  //               const onlyFromBucket =
  //                 index !== -1 ? bucketsentryLst.splice(index, 1)[0] : null;

  //               console.log(onlyFromBucket); // { "name": "91+", "from": 91 }
  //               console.log(bucketsentryLst); // Remaining buckets

  //               console.log(
  //                 ":: ",
  //                 entry.excludeFromComputation,
  //                 "++ :: ",
  //                 entry.excludeFromComputation
  //               );
  //               categorysPDObj[key].values = {
  //                 excludeFromComputation: entry.excludeFromComputation,
  //                 defaultDays: entry.values.defaultDays,
  //                 StageTwoFinalBucketTo: onlyFromBucket?.from,
  //                 buckets: bucketsentryLst,
  //                 frequency: entry.values.frequency,
  //                 StageTwoCategoryNumberOfPeriods: entry.values.periods,
  //                 max: 100,
  //                 min: 1,
  //                 percentage: entry.values.periods,
  //                 StageTwoCategorySAWApE: entry.values.computationMethod,
  //                 computationPercentage: entry.values.computationPercentage,
  //                 netCreditCustomers: entry.values.netCreditCustomers,
  //                 specificAccountExclusions:
  //                   entry.values.specificAccountExclusions,
  //                 addFurtherFactor: entry.values.addFurtherFactor,
  //                 StageTwoFactor: {
  //                   method: entry.values.additionalFactor?.method || "multiply",
  //                   percentage: entry.values.additionalFactor?.percentage || "",
  //                   remarks: entry.values.additionalFactor?.remarks || "",
  //                 },
  //               };
  //             }
  //           }

  //           // now categorysPDObj has your scenario’s values where IDs matched
  //           console.log(categorysPDObj);
  //         } else {
  //           console.log(" senarioData :: ", senarioData);

  //           // stage Two pre fill data
  //           setStageTwoScenarioModel(senarioData?.model);
  //           setStageTwoCategorization(senarioData?.categorize);
  //           setStageTwoDefineDefault(senarioData?.global?.defaultDays);
  //           setDefineAgingBuckets(
  //             senarioData?.global?.bucketOneNotDue === "Yes" ? true : false
  //           );

  //           let bucketsDt = senarioData?.global?.buckets || [];

  //           const normalBuckets = [];

  //           bucketsDt.forEach((b) => {
  //             if (b.to !== undefined) {
  //               normalBuckets.push({ from: String(b.from), to: String(b.to) });
  //             }
  //           });

  //           setStageTwoFinalBucket(
  //             senarioData?.global?.StageTwoFinalBucket || ""
  //           );


  //           setbucketsLst(normalBuckets);
  //          // setStageTwoFinalBucket(finalBucket);
  //           //setActiveStage(2);

  //           setStageTwoPDCalculation(senarioData?.global?.frequency);
  //           setStageTwoNumberOfPeriods(senarioData?.global?.periods);

  //           setStageTwoSAWApE(senarioPDdata.global.computationMethod);
  //           setStageTwoPercentage(senarioData?.global?.computationPercentage);

  //           setconsiderNetCreditCustomer(
  //             senarioData?.global?.netCreditCustomers
  //           );
  //           setspecificAccountexclusions(
  //             senarioData?.global?.specificAccountExclusions
  //           );
  //           setaddFutuerFactor(senarioData?.global?.addFurtherFactor);

  //           setStageTwoFactor({
  //             method: senarioData?.global?.additionalFactor?.method,
  //             percentage: senarioData?.global?.additionalFactor?.percentage,
  //             remarks: senarioData?.global?.additionalFactor?.remarks,
  //           });
  //           setremarks(senarioData?.global?.additionalFactor?.remarks);
  //         }
  //       })
  //       .catch((error) => {
  //         swal(
  //           "Error",
  //           error.response?.data?.error ||
  //             "fetching error while get update data !",
  //           "error"
  //         );
  //       });
  //   }
  // };
  const updateDefaultValues = () => {
  if (createOrupdate === "updateFlow") {
    getOneReceivableECLScenario(scenarioId)
      .then((response) => {
        let senarioData = response.data.receivableECLScenario;

        // stage One Data Pre fill
        setStageOneScenarioName(senarioData.name);
        setStageOneScenarioApproach(senarioData.provisioningApproach);

        let senarioPDdata = senarioData;

        if (senarioPDdata.categorize === "Yes") {
          setStageTwoCategorization("Yes");

          // FIXED: Use setcategorysPDObj callback to ensure state update
          setcategorysPDObj((prevCategorysPDObj) => {
            const updatedCategories = { ...prevCategorysPDObj };

            for (let i = 0; i < senarioData.categorized.length; i++) {
              const entry = senarioData.categorized[i];
              const key = entry.categoryID + "_" + entry.subcategoryID;
              
              if (updatedCategories[key] && entry.values) {
                let bucketsentryLst = [...entry.values.buckets];
                
                const index = bucketsentryLst.findIndex(
                  (bucket) => !("to" in bucket)
                );
                const onlyFromBucket =
                  index !== -1 ? bucketsentryLst.splice(index, 1)[0] : null;

                updatedCategories[key] = {
                  ...updatedCategories[key],
                  values: {
                    ...updatedCategories[key].values,
                    excludeFromComputation: entry.excludeFromComputation,
                    defaultDays: entry.values.defaultDays,
                    StageTwoFinalBucketTo: onlyFromBucket?.from || "",
                    buckets: bucketsentryLst,
                    frequency: entry.values.frequency,
                    StageTwoCategoryNumberOfPeriods: entry.values.periods,
                    max: 100,
                    min: 1,
                    percentage: entry.values.periods,
                    StageTwoCategorySAWApE: entry.values.computationMethod,
                    computationPercentage: entry.values.computationPercentage,
                    netCreditCustomers: entry.values.netCreditCustomers,
                    specificAccountExclusions: entry.values.specificAccountExclusions,
                    addFurtherFactor: entry.values.addFurtherFactor,
                    StageTwoFactor: {
                      method: entry.values.additionalFactor?.method || "multiply",
                      percentage: entry.values.additionalFactor?.percentage || "",
                      remarks: entry.values.additionalFactor?.remarks || "",
                    },
                  },
                };
              }
            }

            return updatedCategories;
          });
        } else {
          // NO categorization - fill global settings
          setStageTwoScenarioModel(senarioData?.model);
          setStageTwoCategorization(senarioData?.categorize);
          setStageTwoDefineDefault(senarioData?.global?.defaultDays);
          setDefineAgingBuckets(
            senarioData?.global?.bucketOneNotDue === "Yes" ? true : false
          );

          let bucketsDt = senarioData?.global?.buckets || [];
          const normalBuckets = [];

          bucketsDt.forEach((b) => {
            if (b.to !== undefined) {
              normalBuckets.push({ from: String(b.from), to: String(b.to) });
            }
          });

          setStageTwoFinalBucket(senarioData?.global?.StageTwoFinalBucket || "");
          setbucketsLst(normalBuckets);

          setStageTwoPDCalculation(senarioData?.global?.frequency);
          setStageTwoNumberOfPeriods(senarioData?.global?.periods);
          setStageTwoSAWApE(senarioData.global.computationMethod);
          setStageTwoPercentage(senarioData?.global?.computationPercentage);

          setconsiderNetCreditCustomer(senarioData?.global?.netCreditCustomers);
          setspecificAccountexclusions(senarioData?.global?.specificAccountExclusions);
          setaddFutuerFactor(senarioData?.global?.addFurtherFactor);

          setStageTwoFactor({
            method: senarioData?.global?.additionalFactor?.method,
            percentage: senarioData?.global?.additionalFactor?.percentage,
            remarks: senarioData?.global?.additionalFactor?.remarks,
          });
          setremarks(senarioData?.global?.additionalFactor?.remarks);
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error.response?.data?.error || "fetching error while get update data!",
          "error"
        );
      });
  }
};

  // },
  // // only calling all default data was set in the objects
  // [categorysFLFObj])

  const PDCalculationInpts = useRef([]);

  
  function setUseRefIntoInput(InptElement, index) {
    if (InptElement) {
      PDCalculationInpts.current[index] = InptElement;
    } else {
      PDCalculationInpts.current[index] = null;
    }

     PDCalculationInpts.current = PDCalculationInpts.current.slice(
      0,
      StageTwoNumberOfPeriods
    );
  }

  const getPdInputVals = () => {
    const values = PDCalculationInpts.current
      .filter(Boolean) // Remove nulls
      .map((input, i) => ({
        period: (i + 1).toString(),
        percentage: parseFloat(input.value) || 0,
      }));

    // setlistOfYears(values)
    return values;
  };

  useEffect(() => {
    getPdInputVals();
  }, [StageTwoNumberOfPeriods]); // when this state update use effect will be trigered

  const [finallObjectData, setfinallObjectData] = useState();

  const [reviewAndSubmitActiveTab, setreviewAndSubmitActiveTab] = useState();

  useEffect(() => {
    if (finallObjectData?.categorized?.length > 0) {
      setreviewAndSubmitActiveTab(0);
    }
  }, [finallObjectData?.categorized]);

  const [companyName, setcompanyName] = useState(""); // company name

  const [showScenarioNameError, setShowScenarioNameError] = useState(false);
  return (
    <div style={{ display: "flex" }} className={eclCss.custmfadein}>
      <CompanyEditSideMenu
        activeTab={"Accounting Policies"}
        companyID={companyID}
        companyDataCheck={true}
        setcompanyName={setcompanyName}
      />

      <div className={eclCss.mainContainer}>
        <EclHeader
          companyID={companyID}
          createOrupdate={createOrupdate}
          scenarioId={scenarioId}
          ActiveStage={ActiveStage}
          setActiveStage={setActiveStage}
          companyName={companyName}
          StageOneScenarioName={StageOneScenarioName}
        />

        <StageNumberBadge
          ActiveStage={ActiveStage}
          setActiveStage={setActiveStage}
        />

        {ActiveStage === 1 ? (
          <div
            className={
              [1, 2, 3, 4, 5].includes(ActiveStage)
                ? eclCss.subContainer
                : eclCss.subCatgeoryContainer
            }
          >
            <div
              className={
                [1, 2, 3, 4, 5].includes(ActiveStage)
                  ? eclCss.stagesContantHoldContainer
                  : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
              }
            >
              <StageOne
                className={eclCss.custmfadein}
                StageOneScenarioName={StageOneScenarioName}
                setStageOneScenarioName={setStageOneScenarioName}
                StageOneScenarioApproach={StageOneScenarioApproach}
                setStageOneScenarioApproach={setStageOneScenarioApproach}
                showError={showScenarioNameError}
                setShowError={setShowScenarioNameError}
                stageOneOptions={stageOneOptions}
                createOrupdate={createOrupdate}
              />
            </div>
          </div>
        ) : ActiveStage === 2 ? (
          <div
            className={
              [1, 2, 3, 4, 5].includes(ActiveStage)
                ? eclCss.subContainer
                : eclCss.subCatgeoryContainer
            }
          >
            <div
              className={
                [1, 2, 3, 4, 5].includes(ActiveStage)
                  ? eclCss.stagesContantHoldContainer
                  : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
              }
            >
              <StageTwo
                StageTwoFinalBucket={StageTwoFinalBucket}
                setStageTwoFinalBucket={setStageTwoFinalBucket}
                StageTwoDefineDefault={StageTwoDefineDefault}
                setStageTwoDefineDefault={setStageTwoDefineDefault}
                remarks={remarks}
                setremarks={setremarks}
                StageTwoFactor={StageTwoFactor}
                setStageTwoFactor={setStageTwoFactor}
                handleToggle={handleToggle}
                DefineAgingBuckets={DefineAgingBuckets}
                setDefineAgingBuckets={setDefineAgingBuckets}
                bucketsLst={bucketsLst}
                handleInputChange={handleInputChange}
                handleAddBucket={handleAddBucket}
                handleRemove={handleRemove}
                setbucketsLst={setbucketsLst}
                ActiveStage={ActiveStage}
                setActiveStage={setActiveStage}
                considerNetCreditCustomer={considerNetCreditCustomer}
                setconsiderNetCreditCustomer={setconsiderNetCreditCustomer}
                specificAccountexclusions={specificAccountexclusions}
                setspecificAccountexclusions={setspecificAccountexclusions}
                addFutuerFactor={addFutuerFactor}
                setaddFutuerFactor={setaddFutuerFactor}
                StageTwoScenarioModel={StageTwoScenarioModel}
                setStageTwoScenarioModel={setStageTwoScenarioModel}
                StageTwoCategorization={StageTwoCategorization}
                setStageTwoCategorization={setStageTwoCategorization}
                StageTwoPDCalculation={StageTwoPDCalculation}
                setStageTwoPDCalculation={setStageTwoPDCalculation}
                StageTwoNumberOfPeriods={StageTwoNumberOfPeriods}
                setStageTwoNumberOfPeriods={setStageTwoNumberOfPeriods}
                StageTwoSAWApE={StageTwoSAWApE}
                setStageTwoSAWApE={setStageTwoSAWApE}
                StageTwoPercentage={StageTwoPercentage}
                setStageTwoPercentage={setStageTwoPercentage}
                PDCalculationInpts={PDCalculationInpts}
                setUseRefIntoInput={setUseRefIntoInput}
                getPdInputVals={getPdInputVals}
                stageTwoOptions={stageTwoOptions}
                stageTwoOptionsAddOrMulti={stageTwoOptionsAddOrMulti}
                stageTwoMin={stageTwoMin}
                stageTwoMax={stageTwoMax}
                stageTwoPercentage={stageTwoPercentage}
                getPeriodLabel={getPeriodLabel}
                periodValues={periodValues}
                handlePeriodChange={handlePeriodChange}
                interCompanyBalances={interCompanyBalances}
                setInterCompanyBalances={setInterCompanyBalances}
              />
            </div>
          </div>
        ) : ActiveStage === "C2" ? (
          <React.Fragment>
            <div
              className={
                [1, 2, 3, 4, 5].includes(ActiveStage)
                  ? eclCss.subContainer
                  : eclCss.subCatgeoryContainer_
              }
            >
              <div
                className={
                  [1, 2, 3, 4, 5].includes(ActiveStage)
                    ? eclCss.stagesContantHoldContainer
                    : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                }
              >
                <StageTwoCategoryHeader
                  StageTwoCategoryScenarioModel={StageTwoCategoryScenarioModel}
                  setStageTwoCategoryScenarioModel={
                    setStageTwoCategoryScenarioModel
                  }
                  StageTwoOptions={StageTwoOptions}
                  StageTwoCategoryCategorization={
                    StageTwoCategoryCategorization
                  }
                  setStageTwoCategoryCategorization={
                    setStageTwoCategoryCategorization
                  }
                  ActiveStage={ActiveStage}
                  setActiveStage={setActiveStage}
                  setStageTwoCategorization={setStageTwoCategorization}
                />

                <StageTwoCategory
                  categorysPDObj={categorysPDObj}
                  setcategorysPDObj={setcategorysPDObj}
                  StageTwoCategoryScenarioModel={StageTwoCategoryScenarioModel}
                  setStageTwoCategoryScenarioModel={
                    setStageTwoCategoryScenarioModel
                  }
                  StageTwoCategoryCategorization={
                    StageTwoCategoryCategorization
                  }
                  setStageTwoCategoryCategorization={
                    setStageTwoCategoryCategorization
                  }
                  StageTwoOptions={StageTwoOptions}
                  optionsMultiplePDPercentage={optionsMultiplePDPercentage}
                  StageTwoActiveCategory={StageTwoActiveCategory}
                  setStageTwoActiveCategory={setStageTwoActiveCategory}
                  categorysData={categorysData}
                  getPeriodLabel={getPeriodLabel}
                  handleCategoryBucketToChange={handleCategoryBucketToChange}
                  handleAddCategoryBucket={handleAddCategoryBucket}
                  getCategoryFinalBucket={getCategoryFinalBucket}

                />
              </div>
            </div>
          </React.Fragment>
        ) : ActiveStage === 3 ? (
          <div
            className={
              [1, 2, 3, 4, 5].includes(ActiveStage)
                ? eclCss.subContainerTwo
                : eclCss.subContainerReviewAndSubmit
            }
          >
            <div
              className={
                [1, 2, 3, 4, 5].includes(ActiveStage)
                  ? eclCss.stagesContantHoldContainer
                  : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
              }
            >
              <StageFive
                categorysData={categorysData}
                finallObjectData={finallObjectData}
                setfinallObjectData={setfinallObjectData}
                reviewAndSubmitActiveTab={reviewAndSubmitActiveTab}
                setreviewAndSubmitActiveTab={setreviewAndSubmitActiveTab}
              />
            </div>
          </div>
        ) : null}

        {/* </div> */}

        {/* </div> */}

        <EclFooter
          finallObjectData={finallObjectData}
          setfinallObjectData={setfinallObjectData}
          scenarioId={scenarioId}
          createOrupdate={createOrupdate}
          StageTwoCategorization={StageTwoCategorization}
          companyID={companyID}
          setCompanyID={setCompanyID}
          ActiveStage={ActiveStage}
          setActiveStage={setActiveStage}
          stageOneWholeData={stageOneWholeData}
          setstageOneWholeData={setstageOneWholeData}
          stageTwoWholeData={stageTwoWholeData}
          setstageTwoWholeData={setstageTwoWholeData}
          stageTwoCategoryWholeData={stageTwoCategoryWholeData}
          setstageTwoCategoryWholeData={setstageTwoCategoryWholeData}
          setShowScenarioNameError={setShowScenarioNameError}
        />
      </div>
    </div>
  );
};

export default CreateReceviablesEclScenario;

const StageOne = ({
  StageOneScenarioName,
  setStageOneScenarioName,
  StageOneScenarioApproach,
  setStageOneScenarioApproach,
  showError,
  setShowError,
  stageOneOptions,
  createOrupdate,
}) => {
  return (
    <div className={`${eclCss.stage1MainContainer} ${eclCss.custmfadein}`}>
      <div className={eclCss.stage1SubContainer}>
        <div>
          <span className={eclCss.scenarioLabelClr}>Scenario Name</span>

          <input
            type="text"
            value={StageOneScenarioName || ""}
            onChange={(e) => {
              setStageOneScenarioName(e.target.value);
              if (showError) setShowError(false);
            }}
            placeholder="Enter Scenario Name"
            className={eclCss.scenarioInput}
            style={{
              width: "100%",
              padding: "8px 12px",
              border:
                showError && !StageOneScenarioName
                  ? "1px solid #d32f2f"
                  : "1px solid #c2e6d1",
              borderRadius: "10px",
              backgroundColor: "#f4faf5",
              fontSize: "14px",
              color: "#4d6d64",
              marginTop: "8px",
            }}
          />

          {showError && !StageOneScenarioName && (
            <div
              style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px" }}
            >
              Please fill out this field
            </div>
          )}
        </div>

        <div className={eclCss.approchContainer}>
          <span className={eclCss.scenarioLabelClr}>IndAS Provisioning</span>
          <div className={eclCss.radioContainer}>
            <label
              style={{ marginRight: "30px" }}
              className={eclCss.LabelContant}
              onClick={() => {
                setStageOneScenarioApproach("simplifiedApproach");
              }}
            >
              {StageOneScenarioApproach === "simplifiedApproach" ? (
                <ActiveRadioBtn className={eclCss.custuRadioBtn} />
              ) : (
                <InactiveRadioBtn className={eclCss.custuRadioBtn} />
              )}
              Simplified Approach
            </label>

            <label
              className={`${eclCss.LabelContant} ${eclCss.disabledOption}`}
              onClick={(e) => e.preventDefault()}
            >
              <InactiveRadioBtn className={eclCss.custuRadioBtn} />
              General Approach
            </label>
          </div>
        </div>

        <div className={eclCss.infoStage1}>
          <div className={eclCss.infoStageBox}>
            <div className={eclCss.stage1InfoText}>
              Select how impairment provisions should be calculated. The
              Simplified Approach applies lifetime ECL, while the General
              Approach tracks credit risk changes over time.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StageTwo = ({
  StageTwoFinalBucket,
  setStageTwoFinalBucket,
  StageTwoDefineDefault,
  setStageTwoDefineDefault,
  remarks,
  setremarks,
  StageTwoFactor,
  setStageTwoFactor,
  handleToggle,
  DefineAgingBuckets,
  handleInputChange,
  handleAddBucket,
  bucketsLst,
  ActiveStage,
  setActiveStage,
  setStageTwoScenarioModel,
  setStageTwoCategorization,
  StageTwoCategorization,
  StageTwoPDCalculation,
  setStageTwoPDCalculation,
  StageTwoNumberOfPeriods,
  setStageTwoNumberOfPeriods,
  StageTwoSAWApE,
  setStageTwoSAWApE,
  StageTwoPercentage,
  setStageTwoPercentage,
  stageTwoOptions,
  stageTwoMin,
  stageTwoMax,
  stageTwoPercentage,
  considerNetCreditCustomer,
  setconsiderNetCreditCustomer,
  specificAccountexclusions,
  setspecificAccountexclusions,
  addFutuerFactor,
  setaddFutuerFactor,
  getPeriodLabel,
  periodValues,
  handlePeriodChange,
  setUseRefIntoInput, 
  interCompanyBalances,
  setInterCompanyBalances,
}) => {
  return (
    <div className={`${eclCss.stage2Container} ${eclCss.custmfadein}`}>
      <DragDropContext onDragEnd={() => {}}>
        <div className={eclCss.stageLeftContainer}>
          <div className={`${eclCss.stageLeftSubContainer}`}>
            <div className={eclCss.stagelabel}>Model</div>
            <Select
              defaultValue={stageTwoOptions[0]}
              components={{ IndicatorSeparator: () => null }}
              onChange={(selectedOption) =>
                setStageTwoScenarioModel(selectedOption)
              }
              options={stageTwoOptions}
              placeholder="Select Status"
              name="status"
              className={`w-100 mt-0 ${eclCss.selectstyl}`}
              classNamePrefix="select"
              styles={customStyles}
              isClearable={false}
              isSearchable={false}
            />
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
          >
            <div className={eclCss.pdsInptsContainer}>
              <div className={eclCss.stage2labelSide}>Define Default</div>
              <div className={eclCss.custNumInptContainerTwo}>
                <div className={eclCss.custInptBoxTwo}>
                  <input
                    className={eclCss.custInpt}
                    type="text"
                    value={StageTwoDefineDefault}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*$/.test(val)) {
                        setStageTwoDefineDefault(val);
                      } else {
                        setStageTwoDefineDefault("");
                      }
                    }}
                  />
                </div>
                <div className={eclCss.custInptIncDescContainerRitPer}>
                  <div className={eclCss.custInptNumUpArrCont}>Days</div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
          >
            <div
              className={eclCss.pdsInptsContainer}
              style={{ justifyContent: "space-between" }}
            >
              <div className={eclCss.stage2labelSide}>Define Aging Buckets</div>
              {/* <div className={eclCss.agingBucketToggle}>
                <span className="module-toggles">
                  <div className="toggle-item">
                    <div className="toggle-container">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={DefineAgingBuckets}
                          onChange={handleToggle}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                </span>
                &nbsp; Set bucket 1 as "Not Due"
              </div> */}
            </div>
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInptGRP}`}
          >
            <div className={eclCss.pdsInptsContainerGRP}>
              {bucketsLst.map((bucket, index) => {
               const isLast = index === bucketsLst.length - 1;

              return (
                <div key={index} className={eclCss.bucketRowWithBtn}>
                <div className={eclCss.bucketContainerWrapper}>
                 <div className={eclCss.bucketHeading}>Bucket {index + 1}</div>

                 <div className={eclCss.BucketInputContainer}>
                  {index === 0 ? (
                   <>
                    <div className={eclCss.bucketTo}>Upto</div>
                    <input
                     className={eclCss.bucketInputs}
                     type="text"
                     value={bucket.to}
                     onChange={(e) =>
                     handleInputChange(index, "to", e.target.value)
                     }
                   />
                </>
                 ) : (
                 <>
                 <input
                   className={`${eclCss.bucketInputs} ${eclCss.mR10}`}
                   type="text"
                   value={bucket.from}
                    readOnly
                    />
                  <div className={eclCss.bucketTo}>to</div>
                  <input
                    className={eclCss.bucketInputs}
                    type="text"
                    value={bucket.to}
                     onChange={(e) =>
                       handleInputChange(index, "to", e.target.value)
                     }
                   />
                  </>
                 )}

                <div className={eclCss.custInptIncDescContainerRitPer}>
                 <div className={eclCss.custInptNumUpArrCont}>Days</div>
                </div>
             </div>
      </div>

        {isLast && (
         <div className={eclCss.addBtnRightWrapper}>
           <button
            type="button"
            className={eclCss.addBucketBtn}
            onClick={handleAddBucket}
            >
            <GrayAddIcon />
             Add Bucket
           </button>
          </div>
        )}
    </div>
  );
})}


              <div style={{ width: "100%" }}>
                <div className={eclCss.bucketContainerWrapper}>
                  <div className={eclCss.bucketHeading}>Final Bucket</div>
                  <div className={eclCss.BucketInputContainer}>
                    <div className={eclCss.bucketTo}>Beyond</div>
                    <input
                      className={eclCss.bucketInputs}
                      type="text"
                      value={StageTwoFinalBucket }
                      onChange={(e) =>
                        setStageTwoFinalBucket(Number(e.target.value))
                      }
                    />
                    <div className={eclCss.custInptIncDescContainerRitPer}>
                      <div className={eclCss.custInptNumUpArrCont}>Days</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
          >
            <div className={eclCss.stagelabel}>
              Frequency of ECL computation
            </div>
            <div className={eclCss.pdsInptsContainer}>
              <div
                className={`${eclCss.pdInpts} ${eclCss.mR10} ${
                  StageTwoPDCalculation === "yearly"
                    ? eclCss.pdInptsActive
                    : eclCss.pdInptsInActive
                }`}
                onClick={() => setStageTwoPDCalculation("yearly")}
              >
                Yearly Basis
              </div>
              <div
                className={`${eclCss.pdInpts} ${eclCss.mR10} ${
                  StageTwoPDCalculation === "quarterly"
                    ? eclCss.pdInptsActive
                    : eclCss.pdInptsInActive
                }`}
                onClick={() => setStageTwoPDCalculation("quarterly")}
              >
                Quarterly Basis
              </div>
              <div
                className={`${eclCss.pdInpts} ${
                  StageTwoPDCalculation === "monthly"
                    ? eclCss.pdInptsActive
                    : eclCss.pdInptsInActive
                }`}
                onClick={() => setStageTwoPDCalculation("monthly")}
              >
                Monthly Basis
              </div>
            </div>
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
          >
            <div className={eclCss.stagelabel}>
              How many periods to consider?
            </div>
            <div className={eclCss.pdsInptsContainer}>
              <input
                type="range"
                min={stageTwoMin}
                max={stageTwoMax}
                value={StageTwoNumberOfPeriods}
                onChange={(e) =>
                  setStageTwoNumberOfPeriods(Number(e.target.value))
                }
                style={{
                  background: `linear-gradient(to right, #3AB67D ${stageTwoPercentage}%, #CCD5D3 ${stageTwoPercentage}%)`,
                }}
                className={eclCss.slider}
              />
              <div className={eclCss.custNumInptContainer}>
                <div className={eclCss.custInptBox}>
                  <input
                    className={eclCss.custInpt}
                    type="text"
                    value={`${StageTwoNumberOfPeriods} ${getPeriodLabel(
                      StageTwoPDCalculation
                    )}`}
                    readOnly
                  />
                </div>
                <div className={eclCss.custInptIncDescContainer}>
                  <div
                    className={eclCss.custInptNumUpArrCont}
                    onClick={() => {
                      const newVal = Math.min(
                        stageTwoMax,
                        StageTwoNumberOfPeriods + 1
                      );
                      setStageTwoNumberOfPeriods(newVal);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <NumUpArrow className={eclCss.custInptNumSvg} />
                  </div>
                  <div
                    className={eclCss.custInptNumDowArrCont}
                    onClick={() => {
                      const newVal = Math.max(
                        stageTwoMin,
                        StageTwoNumberOfPeriods - 1
                      );
                      setStageTwoNumberOfPeriods(newVal);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <NumDownArrow className={eclCss.custInptNumSvg} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={eclCss.containerSeprator}></div>

        <div className={eclCss.stage2RightContainer}>
          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
          >
            <span className={eclCss.stage2labelSide}>
              Do you want categorization?
            </span>
            <div className={eclCss.stage2radioContainer}>
              <label
                style={{ marginRight: "20px", marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => {
                  setActiveStage("C2");
                  setStageTwoCategorization("Yes");
                }}
              >
                {StageTwoCategorization === "Yes"  ? (
                  <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                  <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
                YES
              </label>

              <label
                style={{ marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => {
                  setActiveStage(2);
                  setStageTwoCategorization("No");
                }}
              >
                {StageTwoCategorization === "No" ? (
                  <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                  <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
                NO
              </label>
            </div>
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
          >
            <div className={eclCss.stage2labelSide}>% Computation</div>
          </div>

          <div
            className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
          >
            <div className={eclCss.stagelabel}></div>
            <div className={eclCss.pdsInptsContainer}>
              <div
                className={`${eclCss.pdInpts} ${eclCss.mR10} ${
                  StageTwoSAWApE === "simpleAverage"
                    ? eclCss.pdInptsActive
                    : eclCss.pdInptsInActive
                }`}
                onClick={() => setStageTwoSAWApE("simpleAverage")}
              >
                Simple Average
              </div>
              <div
                className={`${eclCss.pdInpts} ${
                  StageTwoSAWApE === "weightedAverage"
                    ? eclCss.pdInptsActive
                    : eclCss.pdInptsInActive
                }`}
                onClick={() => setStageTwoSAWApE("weightedAverage")}
              >
                Weighted Average
              </div>
            </div>
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
          >
            <div className={eclCss.pdsInptsContainer}>
              <div className={eclCss.pdInpts}>Enter Percentage</div>
              <div className={eclCss.custNumInptContainer}>
                <div className={eclCss.custInptBox}>
                  <input
                    className={eclCss.custInpt}
                    type="text"
                    value={StageTwoPercentage}
                    onChange={(e) =>
                      setStageTwoPercentage(Number(e.target.value))
                    }
                  />
                </div>
                <div className={eclCss.custInptIncDescContainerRitPer}>
                  <div className={eclCss.custInptNumUpArrCont}>
                    <PercebtageIcn />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {StageTwoSAWApE === "weightedAverage" && (
            <div
              className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
            >
              <div className={eclCss.infoStage2}>
                <div className={eclCss.infoStageBox}>
                  <div className={eclCss.stage1IconBox}>
                    <QuestionMartInfo />
                    &nbsp; &nbsp;
                  </div>
                  <div className={eclCss.stage1InfoText}>
                   Simple Average calculates ECL by taking the direct average across all periods. Weighted Average allows you to assign higher or lower importance to specific periods by applying weights
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
          ></div>

          {StageTwoSAWApE === "weightedAverage" && (
            <div
              className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInptGRP}`}
            >
              <div className={eclCss.pdsInptsContainerGRP}>
                {[...Array(StageTwoNumberOfPeriods)].map((_, i) => (
                  <div key={i} className={eclCss.assIgnedPeriodCalculPD}>
                    <div className={eclCss.inptLabelGrp}>Period-{i + 1}</div>

                    <div className={eclCss.custNumInptContainerGrp}>
                      <div className={eclCss.custInptBoxgrp}>
                        <input
                          className={eclCss.custInpt}
                          type="number"
                          value={
                            periodValues[i] === undefined ? "" : periodValues[i]
                          }
                          onChange={(e) =>
                            handlePeriodChange(i, e.target.value)
                          }
                         ref={(el) => {
                            if (typeof setUseRefIntoInput === "function")
                              setUseRefIntoInput(el, i);
                          }}
                          placeholder="0"
                        />
                      </div>

                      <div className={eclCss.custInptIncDescContainerGRP}>
                        <div
                          className={eclCss.custInptNumUpArrCont}
                          onClick={() => {
                            const newVal = (Number(periodValues[i]) || 0) + 1;
                            handlePeriodChange(i, newVal);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <NumUpArrow className={eclCss.custInptNumSvg} />
                        </div>

                        <div
                          className={eclCss.custInptNumDowArrCont}
                          onClick={() => {
                            const cur = Number(periodValues[i]) || 0;
                            const newVal = cur > 0 ? cur - 1 : 0;
                            handlePeriodChange(i, newVal);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <NumDownArrow className={eclCss.custInptNumSvg} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
          >
            <span className={eclCss.stage2labelSide}>Do you want to exclude intercompany balances from your computation ?</span>
            <div className={eclCss.stage2radioContainer}>
             <label
                style={{ marginRight: "20px", marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => setInterCompanyBalances("Yes")}
             >
               {interCompanyBalances === "Yes" ? (
                <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
               YES
             </label>

             <label
               style={{ marginBottom: "0px" }}
               className={eclCss.stage2LeftCatgeorLabel}
               onClick={() => setInterCompanyBalances("No")}
              >
               {interCompanyBalances === "No" ? (
               <ActiveRadioBtn className={eclCss.custuRadioBtn} />
              ) : (
              <InactiveRadioBtn className={eclCss.custuRadioBtn} />
              )}
               NO
             </label>
            </div>
          </div>
         

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
          >
            <span className={eclCss.stage2labelSide}>
              Do you want to consider net credit customers?
            </span>
            <div className={eclCss.stage2radioContainer}>
              <label
                style={{ marginRight: "20px", marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => setconsiderNetCreditCustomer("Yes")}
              >
                {considerNetCreditCustomer === "Yes" ? (
                  <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                  <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
                YES
              </label>

              <label
                style={{ marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => setconsiderNetCreditCustomer("No")}
              >
                {considerNetCreditCustomer === "No" ? (
                  <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                  <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
                NO
              </label>
            </div>
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
          >
            <span className={eclCss.stage2labelSide}>
              Do you want specific account exclusions?
            </span>
            <div className={eclCss.stage2radioContainer}>
              <label
                style={{ marginRight: "20px", marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => setspecificAccountexclusions("Yes")}
              >
                {specificAccountexclusions === "Yes" ? (
                  <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                  <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
                YES
              </label>

              <label
                style={{ marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => setspecificAccountexclusions("No")}
              >
                {specificAccountexclusions === "No" ? (
                  <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                  <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
                NO
              </label>
            </div>
          </div>

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
          >
            <span className={eclCss.stage2labelSide}>
              Do you want to add a further factor?
            </span>
            <div className={eclCss.stage2radioContainer}>
              <label
                style={{ marginRight: "20px", marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => setaddFutuerFactor("Yes")}
              >
                {addFutuerFactor === "Yes" ? (
                  <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                  <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
                YES
              </label>

              <label
                style={{ marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => setaddFutuerFactor("No")}
              >
                {addFutuerFactor === "No" ? (
                  <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                ) : (
                  <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                )}
                NO
              </label>
            </div>
          </div>

         {addFutuerFactor === "Yes" && (
          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor} ${eclCss.mt15}`}
          >
            <div>
              <div className={eclCss.stage2radioContainer}>
                <label
                  style={{ marginRight: "20px", marginBottom: "0px" }}
                  className={eclCss.stage2LeftCatgeorLabel}
                  onClick={() => {
                    setStageTwoFactor({
                      ...StageTwoFactor,
                      method: "multiply",
                    });
                  }}
                >
                  {StageTwoFactor?.method === "multiply" ? (
                    <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                  ) : (
                    <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                  )}
                  MULTIPLY
                </label>

                <label
                  style={{ marginBottom: "0px" }}
                  className={eclCss.stage2LeftCatgeorLabel}
                  onClick={() => {
                    setStageTwoFactor({
                      ...StageTwoFactor,
                      method: "add",
                    });
                  }}
                >
                  {StageTwoFactor?.method === "add" ? (
                    <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                  ) : (
                    <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                  )}
                  ADD
                </label>
              </div>

              <div className={eclCss.mt15}>
                <div className={eclCss.pdsInptsContainer2}>
                  <div className={eclCss.stage2labelSide}>
                    {StageTwoFactor?.method === "multiply"
                      ? "Multiply by"
                      : "Add by"}
                  </div>

                  <div className={eclCss.custNumInptContainer}>
                    <div className={eclCss.custInptBox}>
                      <input
                        className={eclCss.custInpt}
                        type="text"
                        value={StageTwoFactor?.percentage || ""}
                        onChange={(e) =>
                          setStageTwoFactor({
                            ...StageTwoFactor,
                            percentage: Number(e.target.value) || "",
                          })
                        }
                      />
                    </div>
                    <div className={eclCss.custInptIncDescContainerRitPer}>
                      <div className={eclCss.custInptNumUpArrCont}>
                        <PercebtageIcn />
                      </div>
                    </div>
                  </div>

                  <div className={eclCss.calCulationInfoAlrt2}>
                    <div>
                      <EclExcaclamater />
                    </div>
                    &nbsp;
                    <span className={eclCss.infoText}>
                      This factor will be appropriately added or multiplied to the ECL % computed based on your policy
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
         )}

          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
          >
            <textarea
              className={eclCss.textareaInput}
              placeholder="Enter Remarks ..."
              rows={4}
              value={remarks}
              onChange={(e) => setremarks(e.target.value)}
            ></textarea>
          </div>
        </div>
      </DragDropContext>
    </div>
  );
};

const StageTwoCategoryHeader = ({
  StageTwoCategoryScenarioModel,
  setStageTwoCategoryScenarioModel,
  StageTwoOptions,
  StageTwoCategoryCategorization,
  setStageTwoCategoryCategorization,
  ActiveStage,
  setActiveStage,
  setStageTwoCategorization,
}) => {
  return (
    <div>
      <div
        className={`${eclCss.stageTwoCatgorSelecContainer} ${eclCss.custmfadein}`}
      >
        <div className={eclCss.width40Per}>
          <Select
            defaultValue={StageTwoOptions[0]}
            components={{ IndicatorSeparator: () => null }} // remove separator
            onChange={(selectedOption) =>
              setStageTwoCategoryScenarioModel(selectedOption)
            }
            options={StageTwoOptions}
            placeholder="Select Status"
            name="status"
            className={`w-100 mt-0 ${eclCss.selectstyl}`}
            classNamePrefix="select"
            styles={customStyles}
            isClearable={false}
            isSearchable={false}
          />
        </div>

        <div className={eclCss.width40Per}>
          <div
            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer_}`}
          >
            <span className={eclCss.stage2labelSide}>
              Do you want categorization?
            </span>
            <div className={eclCss.stage2radioContainer}>
              <label
                style={{ marginRight: "20px", marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => {
                  setActiveStage("C2");
                  setStageTwoCategorization("Yes");
                }}
              >
                <div className={eclCss.customRadioOuter}>
                  {ActiveStage !== Number.isInteger(ActiveStage) ? (
                    <div className={eclCss.customRadioInner}></div>
                  ) : (
                    ""
                  )}
                </div>
                YES
              </label>

              <label
                style={{ marginBottom: "0px" }}
                className={eclCss.stage2LeftCatgeorLabel}
                onClick={() => {
                  setActiveStage(2);
                  setStageTwoCategorization("No");
                }}
              >
                <div className={eclCss.customRadioOuter}>
                  {ActiveStage === Number.isInteger(ActiveStage) ? (
                    <div className={eclCss.customRadioInner}></div>
                  ) : (
                    ""
                  )}
                </div>
                NO
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StageTwoCategory = ({
  categorysPDObj,
  setcategorysPDObj,
  StageTwoActiveCategory,
  setStageTwoActiveCategory,
  categorysData,
  getPeriodLabel,
  handleCategoryBucketToChange,
  handleAddCategoryBucket,
  getCategoryFinalBucket,
}) => {
  return (
    <React.Fragment>
      {/* Category Tabs */}
      <div className={`${eclCss.custmfadein} ${eclCss.categoryContainerMain}`}>
        <div className={eclCss.catgegoryContainer}>
          {categorysData.map((item, index) => (
            <div
              key={index}
              className={
                StageTwoActiveCategory === index
                  ? index === 0
                    ? eclCss.activeCategoryTab
                    : eclCss.activeCategoryTabNoRadius
                  : eclCss.inActiveCategoryTab
              }
              onClick={() => {
                setStageTwoActiveCategory(index);
              }}
            >
              <div key={index}>
                <div className={eclCss.WMaxContant}> {item.category} </div>
                {/* {item.categoryID} */}
                <small className={eclCss.smallTxt}>{item.subcategory}</small>
                {/* {item.subcategoryID} */}
              </div>
            </div>
          ))}
        </div>

        {categorysData.map((item, index) => (
          // StageTwoActiveCategory === index ?
          <div
            key={index}
            // hide and un hide the category container
            className={
              StageTwoActiveCategory === index
                ? eclCss.containerShow
                : eclCss.containerNone
            }
          >
            <div key={index} className={eclCss.stage2CategoryContainer_}>
              <div className={eclCss.stageLeftContainer} key={index}>
                <div key={index}>
                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
                  >
                    <div
                      className={eclCss.pdsInptsContainer}
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className={eclCss.agingBucketToggle}>
                        <span className="module-toggles">
                          <div className="toggle-item">
                            <div className="toggle-container">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    categorysPDObj[
                                      `${item.categoryID}_${item.subcategoryID}`
                                    ]?.values?.excludeFromComputation === "Yes"
                                  }
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const subID = item.subcategoryID;
                                    const categoryID = item.categoryID;
                                    setcategorysPDObj((prev) => {
                                      const key = `${categoryID}_${subID}`; // Build the full key
                                      const old = prev[key] || {};
                                      const oldValues = old.values || {};

                                      return {
                                        ...prev,
                                        [key]: {
                                          ...old,
                                          values: {
                                            ...oldValues,
                                            excludeFromComputation: isChecked
                                              ? "Yes"
                                              : "No",
                                          },
                                        },
                                      };
                                    });
                                  }}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>
                        </span>
                        &nbsp; Exclude category from computation
                      </div>
                    </div>
                  </div>

                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
                  >
                    <div className={eclCss.pdsInptsContainer}>
                      <div className={eclCss.stage2labelSide}>Set Default</div>
                      <div className={eclCss.custNumInptContainerTwo}>
                        <div className={eclCss.custInptBoxTwo}>
                          <input
                            className={eclCss.custInpt}
                            type="text"
                            value={
                              categorysPDObj[
                                `${item.categoryID}_${item.subcategoryID}`
                              ]?.values?.defaultDays || ""
                            }
                            onChange={(e) => {
                              const val = Number(e.target.value);
                              const key = `${item.categoryID}_${item.subcategoryID}`;
                              setcategorysPDObj((prev) => {
                                const old = prev[key] || {};
                                const oldValues = old.values || {};
                                return {
                                  ...prev,
                                  [key]: {
                                    ...old,
                                    values: {
                                      ...oldValues,
                                      defaultDays: val,
                                    },
                                  },
                                };
                              });
                            }}
                          />
                        </div>
                        <div className={eclCss.custInptIncDescContainerRitPer}>
                          <div className={eclCss.custInptNumUpArrCont}>
                            Days
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
                  >
                   <div
                      className={eclCss.pdsInptsContainer}
                      style={{ justifyContent: "space-between" }}
                      >
                      <div className={eclCss.stage2labelSide}>
                        Define Aging Buckets
                      </div>
                    </div>
                   </div>

                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInptGRP}`}
                  >
                    
                    <div className={eclCss.pdsInptsContainerGRP}>
                     {categorysPDObj[
                        `${item.categoryID}_${item.subcategoryID}`
                      ]?.values?.buckets?.map((bucket, index) => {
                        const key = `${item.categoryID}_${item.subcategoryID}`;

                        return (

                        <div
                          key={index}
                          className={eclCss.bucketContainerWrapper}
                        >
                          <div className={eclCss.bucketHeading}>
                            Bucket {index + 1}
                          </div>
                          <div className={eclCss.BucketInputContainer}>
                          {index === 0 ? (
                            <>
                              <div className={eclCss.bucketTo}>Upto</div>
                              <input
                                className={eclCss.bucketInputs}
                                type="text"
                                value={bucket.to || ""}
                                onChange={(e) =>
                                  handleCategoryBucketToChange(
                                    key,
                                    index,
                                    e.target.value
                                  )
                                }
                              />
                            </>
                          ) : (
                            <>
                              <input
                                className={`${eclCss.bucketInputs} ${eclCss.mR10}`}
                                type="text"
                                value={bucket.from}
                                readOnly
                              />
                              <div className={eclCss.bucketTo}>to</div>
                              <input
                                className={eclCss.bucketInputs}
                                type="text"
                                value={bucket.to || ""}
                                onChange={(e) =>
                                  handleCategoryBucketToChange(
                                    key,
                                    index,
                                    e.target.value
                                  )
                                }
                              />
                            </>
                          )}

                            <div
                              className={eclCss.custInptIncDescContainerRitPer}
                            >
                              <div className={eclCss.custInptNumUpArrCont}>
                                Days
                              </div>
                            </div>

                            {/* REMOVE BUTTON (ready to use) */}
                            {/* <button
                                                            type="button"
                                                             className={eclCss.removeBucketBtn}
                                                            onClick={() => {
                                                            const cate = item.categoryID;
                                                            const sub = item.subcategoryID;
                                                            const key = `${cate}_${sub}`;
                                                            setcategorysPDObj(prev => {
                                                                const old = prev[key] || {};
                                                                const oldValues = old.values || {};
                                                                const updatedBuckets = [...(oldValues.buckets || [])];
                                                                updatedBuckets.splice(index, 1);
                                                                return {
                                                                ...prev,
                                                                [key]: {
                                                                    ...old,
                                                                    values: {
                                                                    ...oldValues,
                                                                    buckets: updatedBuckets
                                                                    }
                                                                }
                                                                };
                                                            });
                                                            }}
                                                        >
                                                            🗑️
                                                        </button> */}
                          </div>
                        </div>
                      );
                    })}
                     <button
                      type="button"
                      className={eclCss.addBucketBtn}
                      onClick={() =>
                        handleAddCategoryBucket(
                          `${item.categoryID}_${item.subcategoryID}`
                        )
                      }
                    >
                      <GrayAddIcon />
                      Add Bucket
                    </button>



                      <div style={{ width: "100%" }}>
                        <div className={eclCss.bucketContainerWrapper}>
                          <div className={eclCss.bucketHeading}>
                            Final Bucket
                          </div>
                          <div className={eclCss.BucketInputContainer}>
                            <div className={eclCss.bucketTo}>Beyond</div>
                            {/* <input
                              className={eclCss.bucketInputs}
                              type="text"
                              value={
                                categorysPDObj[
                                  `${item.categoryID}_${item.subcategoryID}`
                                ]?.values?.StageTwoFinalBucketTo || ""
                              }
                              onChange={(e) => {
                                const val = e.target.value;
                                const cate = item.categoryID;
                                const sub = item.subcategoryID;
                                const key = `${cate}_${sub}`;
                                setcategorysPDObj((prev) => {
                                  const old = prev[key] || {};
                                  const oldValues = old.values || {};
                                  return {
                                    ...prev,
                                    [key]: {
                                      ...old,
                                      values: {
                                        ...oldValues,
                                        StageTwoFinalBucketTo: val,
                                      },
                                    },
                                  };
                                });
                              }}
                            /> */}
                            <input
                              className={eclCss.bucketInputs}
                              type="text"
                              readOnly
                              value={
                                getCategoryFinalBucket(
                                  categorysPDObj[
                                    `${item.categoryID}_${item.subcategoryID}`
                                  ]?.values?.buckets || []
                                )
                                  ? `${getCategoryFinalBucket(
                                      categorysPDObj[
                                        `${item.categoryID}_${item.subcategoryID}`
                                      ]?.values?.buckets
                                    )}`
                                  : ""
                              }
                            />

                            <div
                              className={eclCss.custInptIncDescContainerRitPer}
                            >
                              <div className={eclCss.custInptNumUpArrCont}>
                                Days
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    key={index}
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
                  >
                    <div className={eclCss.stagelabel}>
                      Frequency for PD Calculation
                    </div>
                    <div className={eclCss.pdsInptsContainer}>
                      <div
                        className={`${eclCss.pdInpts} ${eclCss.mR10} ${
                          categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values.frequency === "yearly"
                            ? eclCss.pdInptsActive
                            : eclCss.pdInptsInActive
                        }`}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => ({
                            ...prev,
                            [key]: {
                              ...prev[key],
                              values: {
                                ...prev[key]?.values,
                                frequency: "yearly",
                              },
                            },
                          }));
                        }}
                      >
                        Yearly Basis
                      </div>

                      <div
                        className={`${eclCss.pdInpts} ${eclCss.mR10} ${
                          categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values.frequency === "quarterly"
                            ? eclCss.pdInptsActive
                            : eclCss.pdInptsInActive
                        }`}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => ({
                            ...prev,
                            [key]: {
                              ...prev[key],
                              values: {
                                ...prev[key]?.values,
                                frequency: "quarterly",
                              },
                            },
                          }));
                        }}
                      >
                        Quarterly Basis
                      </div>

                      <div
                        className={`${eclCss.pdInpts} ${
                          categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values.frequency === "monthly"
                            ? eclCss.pdInptsActive
                            : eclCss.pdInptsInActive
                        }`}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => ({
                            ...prev,
                            [key]: {
                              ...prev[key],
                              values: {
                                ...prev[key]?.values,
                                frequency: "monthly",
                              },
                            },
                          }));
                        }}
                      >
                        Monthly Basis
                      </div>
                    </div>
                  </div>

                  <div
                    key={index}
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
                  >
                    <div className={eclCss.stagelabel}>
                      How many periods to consider?
                    </div>
                    <div className={eclCss.pdsInptsContainer}>
                      <input
                        type="range"
                        min={
                          categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values.min
                        }
                        max={
                          categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values.max
                        }
                        value={
                          categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values.StageTwoCategoryNumberOfPeriods
                        }
                        onChange={(e) => {
                          const val = Number(e.target.value);
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => {
                            const old = prev[key] || {};
                            const oldGlobal = old.values || {};
                            const min = oldGlobal.min || 1;
                            const max = oldGlobal.max || 100;
                            const percentage =
                              ((val - min) / (max - min)) * 100;

                            return {
                              ...prev,
                              [key]: {
                                ...old,
                                values: {
                                  ...oldGlobal,
                                  StageTwoCategoryNumberOfPeriods: val,
                                  percentage: percentage,
                                  weights: Array.from(
                                    { length: val },
                                    (_, i) => ({
                                      period: (i + 1).toString(),
                                      percentage: 0,
                                    })
                                  ),
                                },
                              },
                            };
                          });
                        }}
                        style={{
                          background: `linear-gradient(to right, #3AB67D ${
                            categorysPDObj[
                              `${item.categoryID}_${item.subcategoryID}`
                            ]?.values.percentage
                          }%, #CCD5D3 ${
                            categorysPDObj[
                              `${item.categoryID}_${item.subcategoryID}`
                            ]?.values.percentage
                          }%)`,
                        }}
                        className={eclCss.slider}
                      />

                      <div key={index} className={eclCss.custNumInptContainer}>
                        <div className={eclCss.custInptBox}>
                          <input
                            className={eclCss.custInpt}
                            type="text"
                            value={`${
                              categorysPDObj[
                                `${item.categoryID}_${item.subcategoryID}`
                              ]?.values.StageTwoCategoryNumberOfPeriods
                            } ${getPeriodLabel(
                              categorysPDObj[
                                `${item.categoryID}_${item.subcategoryID}`
                              ]?.values.frequency
                            )}`}
                            onChange={(e) => {
                              const val = Number(e.target.value);
                              const key = `${item.categoryID}_${item.subcategoryID}`;
                              setcategorysPDObj((prev) => {
                                const old = prev[key] || {};
                                const oldGlobal = old.values || {};
                                const min = oldGlobal.min || 1;
                                const max = oldGlobal.max || 100;
                                const percentage =
                                  ((val - min) / (max - min)) * 100;

                                return {
                                  ...prev,
                                  [key]: {
                                    ...old,
                                    values: {
                                      ...oldGlobal,
                                      StageTwoCategoryNumberOfPeriods: val,
                                      percentage: percentage,
                                      weights: Array.from(
                                        { length: val },
                                        (_, i) => ({
                                          period: (i + 1).toString(),
                                          percentage: 0,
                                        })
                                      ),
                                    },
                                  },
                                };
                              });
                            }}
                          />
                        </div>
                        <div
                          key={index}
                          className={eclCss.custInptIncDescContainer}
                        >
                          <div
                            className={eclCss.custInptNumUpArrCont}
                            onClick={() => {
                              const key = `${item.categoryID}_${item.subcategoryID}`;
                              setcategorysPDObj((prev) => {
                                const old = prev[key] || {};
                                const oldGlobal = old.values || {};
                                const min = oldGlobal.min || 1;
                                const max = oldGlobal.max || 100;
                                const currentVal =
                                  oldGlobal.StageTwoCategoryNumberOfPeriods ||
                                  0;
                                const newVal = Math.min(max, currentVal + 1);
                                const percentage =
                                  ((newVal - min) / (max - min)) * 100;

                                return {
                                  ...prev,
                                  [key]: {
                                    ...old,
                                    values: {
                                      ...oldGlobal,
                                      StageTwoCategoryNumberOfPeriods: newVal,
                                      percentage: percentage,
                                      weights: Array.from(
                                        { length: newVal },
                                        (_, i) => ({
                                          period: (i + 1).toString(),
                                          percentage: 0,
                                        })
                                      ),
                                    },
                                  },
                                };
                              });
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <NumUpArrow className={eclCss.custInptNumSvg} />
                          </div>
                          <div
                            className={eclCss.custInptNumDowArrCont}
                            onClick={() => {
                              const key = `${item.categoryID}_${item.subcategoryID}`;
                              setcategorysPDObj((prev) => {
                                const old = prev[key] || {};
                                const oldGlobal = old.values || {};
                                const min = oldGlobal.min || 1;
                                const max = oldGlobal.max || 100;
                                const currentVal =
                                  oldGlobal.StageTwoCategoryNumberOfPeriods ||
                                  0;
                                const newVal = Math.max(min, currentVal - 1);
                                const percentage =
                                  ((newVal - min) / (max - min)) * 100;

                                return {
                                  ...prev,
                                  [key]: {
                                    ...old,
                                    values: {
                                      ...oldGlobal,
                                      StageTwoCategoryNumberOfPeriods: newVal,
                                      percentage: percentage,
                                      weights: Array.from(
                                        { length: newVal },
                                        (_, i) => ({
                                          period: (i + 1).toString(),
                                          percentage: 0,
                                        })
                                      ),
                                    },
                                  },
                                };
                              });
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <NumDownArrow className={eclCss.custInptNumSvg} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* seprator */}
              <div key={index} className={eclCss.containerSeprator}></div>

              <div key={index} className={eclCss.stage2RightContainer}>
                <div
                  key={index}
                  className={`${eclCss.UnhideContainerHideCategoryContainer}`}
                >
                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
                  >
                    <div className={eclCss.stage2labelSide}>% Computation</div>
                  </div>

                  <div
                    key={index}
                    className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
                  >
                    <div className={eclCss.stagelabel}></div>
                    <div className={eclCss.pdsInptsContainer}>
                      <div
                        className={`${eclCss.pdInpts} ${
                          categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values.StageTwoCategorySAWApE === "simpleAverage"
                            ? eclCss.pdInptsActive
                            : eclCss.pdInptsInActive
                        }`}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => ({
                            ...prev,
                            [key]: {
                              ...prev[key],
                              values: {
                                ...prev[key]?.values,
                                StageTwoCategorySAWApE: "simpleAverage",
                              },
                            },
                          }));
                        }}
                      >
                        Simple Average
                      </div>

                      <div
                        className={`${eclCss.pdInpts} ${
                          categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values.StageTwoCategorySAWApE === "weightedAverage"
                            ? eclCss.pdInptsActive
                            : eclCss.pdInptsInActive
                        }`}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => ({
                            ...prev,
                            [key]: {
                              ...prev[key],
                              values: {
                                ...prev[key]?.values,
                                StageTwoCategorySAWApE: "weightedAverage",
                              },
                            },
                          }));
                        }}
                      >
                        Weighted Average
                      </div>
                    </div>
                  </div>

                  <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                  <div className={eclCss.pdsInptsContainer}>
                  <div className={eclCss.pdInpts}>Enter Percentage</div>

                    <div className={eclCss.custNumInptContainer}>
                      <div className={eclCss.custInptBox}>
                        <input
                          className={eclCss.custInpt}
                          type="text"
                          value={
                            categorysPDObj[
                              `${item.categoryID}_${item.subcategoryID}`
                            ]?.values?.computationPercentage || ""
                          }
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                              setcategorysPDObj(prev => {
                                const key = `${item.categoryID}_${item.subcategoryID}`;
                                return {
                                  ...prev,
                                  [key]: {
                                    ...prev[key],
                                    values: {
                                      ...prev[key].values,
                                      computationPercentage: "",
                                    },
                                  },
                                };
                              });
                              return;
                            }

                            if (/^\d+$/.test(val)) {
                              setcategorysPDObj(prev => {
                                const key = `${item.categoryID}_${item.subcategoryID}`;
                                return {
                                  ...prev,
                                  [key]: {
                                    ...prev[key],
                                    values: {
                                      ...prev[key].values,
                                      computationPercentage: val,
                                    },
                                  },
                                };
                              });
                            }
                          }}
                        />
                      </div>

                      <div className={eclCss.custInptIncDescContainerRitPer}>
                        <div className={eclCss.custInptNumUpArrCont}>
                          <PercebtageIcn />
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
              


                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.StageTwoCategorySAWApE ===
                          "weightedAverage" && (
                          <div
                            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}
                          >
                            <div className={eclCss.infoStage2}>
                              <div className={eclCss.infoStageBox}>
                                <div className={eclCss.stage1IconBox}>
                                  <QuestionMartInfo />
                                  &nbsp; &nbsp;
                                </div>
                                <div className={eclCss.stage1InfoText}>
                                   Simple Average calculates ECL by taking the direct average across all periods. Weighted Average allows you to assign higher or lower importance to specific periods by applying weights
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <div
                          className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
                        >
                          <span className={eclCss.stage2labelSide}>
                            Do you want specific weights assigned to periods
                            while calculating PD?
                          </span>
                          <div className={eclCss.stage2radioContainer}>
                            <label
                              style={{
                                marginRight: "20px",
                                marginBottom: "0px",
                              }}
                              className={eclCss.stage2LeftCatgeorLabel}
                              onClick={() => {
                                const key = `${item.categoryID}_${item.subcategoryID}`;
                                setcategorysPDObj((prev) => ({
                                  ...prev,
                                  [key]: {
                                    ...prev[key],
                                    values: {
                                      ...prev[key]?.values,
                                      StageTwoCategorySAWApE: "weightedAverage",
                                    },
                                  },
                                }));
                              }}
                            >
                              {categorysPDObj[
                                `${item.categoryID}_${item.subcategoryID}`
                              ]?.values?.StageTwoCategorySAWApE ===
                              "weightedAverage" ? (
                                <ActiveRadioBtn
                                  className={eclCss.custuRadioBtn}
                                />
                              ) : (
                                <InactiveRadioBtn
                                  className={eclCss.custuRadioBtn}
                                />
                              )}
                              YES
                            </label>

                            <label
                              style={{ marginBottom: "0px" }}
                              className={eclCss.stage2LeftCatgeorLabel}
                              onClick={() => {
                                const key = `${item.categoryID}_${item.subcategoryID}`;
                                setcategorysPDObj((prev) => ({
                                  ...prev,
                                  [key]: {
                                    ...prev[key],
                                    values: {
                                      ...prev[key]?.values,
                                      StageTwoCategorySAWApE: "simpleAverage",
                                    },
                                  },
                                }));
                              }}
                            >
                              {categorysPDObj[
                                `${item.categoryID}_${item.subcategoryID}`
                              ]?.values?.StageTwoCategorySAWApE !==
                              "weightedAverage" ? (
                                <ActiveRadioBtn
                                  className={eclCss.custuRadioBtn}
                                />
                              ) : (
                                <InactiveRadioBtn
                                  className={eclCss.custuRadioBtn}
                                />
                              )}
                              NO
                            </label>
                          </div>
                        </div>

                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.StageTwoCategorySAWApE ===
                          "weightedAverage" && (
                          <div
                            className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInptGRP}`}
                          >
                            <div className={eclCss.pdsInptsContainerGRP}>
                              {[
                                ...Array(
                                  categorysPDObj[
                                    `${item.categoryID}_${item.subcategoryID}`
                                  ]?.values?.StageTwoCategoryNumberOfPeriods
                                ),
                              ].map((_, i) => {
                                const totalPeriods =
                                  categorysPDObj[
                                    `${item.categoryID}_${item.subcategoryID}`
                                  ]?.values?.StageTwoCategoryNumberOfPeriods ||
                                  0;

                                return (
                                  <div
                                    key={i}
                                    className={eclCss.assIgnedPeriodCalculPD}
                                  >
                                    <div
                                      key={i}
                                      className={eclCss.inptLabelGrp}
                                    >
                                      Period-{i + 1}
                                    </div>
                                    <div
                                      className={eclCss.custNumInptContainerGrp}
                                    >
                                      <div className={eclCss.custInptBoxgrp}>
                                        <input
                                          className={eclCss.custInpt}
                                          type="text"
                                          value={
                                            categorysPDObj[
                                              `${item.categoryID}_${item.subcategoryID}`
                                            ]?.values?.weights?.[i]
                                              ?.percentage ?? totalPeriods
                                          }
                                          placeholder={totalPeriods.toString()}
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            const key = `${item.categoryID}_${item.subcategoryID}`;
                                            setcategorysPDObj((prev) => {
                                              const old = prev[key] || {};
                                              const oldValues =
                                                old.values || {};
                                              const oldWeights =
                                                oldValues.weights || [];

                                              const updatedWeights = [
                                                ...oldWeights,
                                              ];
                                              updatedWeights[i] = {
                                                period: (i + 1).toString(),
                                                percentage: Number(val) || 0,
                                              };

                                              return {
                                                ...prev,
                                                [key]: {
                                                  ...old,
                                                  values: {
                                                    ...oldValues,
                                                    weights: updatedWeights,
                                                  },
                                                },
                                              };
                                            });
                                          }}
                                        />
                                      </div>
                                      <div
                                        className={
                                          eclCss.custInptIncDescContainerGRP
                                        }
                                      >
                                        <div
                                          className={
                                            eclCss.custInptNumUpArrCont
                                          }
                                        >
                                          <NumUpArrow
                                            className={eclCss.custInptNumSvg}
                                          />
                                        </div>
                                        <div
                                          className={
                                            eclCss.custInptNumDowArrCont
                                          }
                                        >
                                          <NumDownArrow
                                            className={eclCss.custInptNumSvg}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}

                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
                  >
                    <span className={eclCss.stage2labelSide}>
                      Do you want to exclude intercompany balances from your computation ?
                    </span>
                      <div className={eclCss.stage2radioContainer}>
                  
                      <label
                        style={{ marginRight: "20px", marginBottom: "0px" }}
                        className={eclCss.stage2LeftCatgeorLabel}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj(prev => ({
                            ...prev,
                            [key]: {
                              ...prev[key],
                              values: {
                                ...prev[key].values,
                                interCompanyBalances: "Yes",
                              },
                            },
                          }));
                        }}
                      >
                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.interCompanyBalances === "Yes" ? (
                          <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                        ) : (
                          <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                        )}
                        YES
                      </label>

                      {/* NO */}
                      <label
                        style={{ marginBottom: "0px" }}
                        className={eclCss.stage2LeftCatgeorLabel}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj(prev => ({
                            ...prev,
                            [key]: {
                              ...prev[key],
                              values: {
                                ...prev[key].values,
                                interCompanyBalances: "No",
                              },
                            },
                          }));
                        }}
                      >
                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.interCompanyBalances !== "Yes" ? (
                          <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                        ) : (
                          <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                        )}
                        NO
                      </label>
                    </div>
                  </div>


                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
                  >
                    <span className={eclCss.stage2labelSide}>
                      Do you want to consider net credit customers?
                    </span>
                    <div className={eclCss.stage2radioContainer}>
                      {/* YES */}
                      <label
                        style={{ marginRight: "20px", marginBottom: "0px" }}
                        className={eclCss.stage2LeftCatgeorLabel}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => {
                            const old = prev[key] || {};
                            const oldValues = old.values || {};
                            return {
                              ...prev,
                              [key]: {
                                ...old,
                                values: {
                                  ...oldValues,
                                  netCreditCustomers: "Yes",
                                },
                              },
                            };
                          });
                        }}
                      >
                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.netCreditCustomers === "Yes" ? (
                          <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                        ) : (
                          <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                        )}
                        YES
                      </label>

                      {/* NO */}
                      <label
                        style={{ marginBottom: "0px" }}
                        className={eclCss.stage2LeftCatgeorLabel}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => {
                            const old = prev[key] || {};
                            const oldValues = old.values || {};
                            return {
                              ...prev,
                              [key]: {
                                ...old,
                                values: {
                                  ...oldValues,
                                  netCreditCustomers: "No",
                                },
                              },
                            };
                          });
                        }}
                      >
                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.netCreditCustomers === "No" ? (
                          <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                        ) : (
                          <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                        )}
                        NO
                      </label>
                    </div>
                  </div>

                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
                  >
                    <span className={eclCss.stage2labelSide}>
                      Do you want specific account exclusions?
                    </span>
                    <div className={eclCss.stage2radioContainer}>
                      <label
                        style={{ marginRight: "20px", marginBottom: "0px" }}
                        className={eclCss.stage2LeftCatgeorLabel}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => {
                            const old = prev[key] || {};
                            const oldValues = old.values || {};
                            return {
                              ...prev,
                              [key]: {
                                ...old,
                                values: {
                                  ...oldValues,
                                  specificAccountExclusions: "Yes",
                                },
                              },
                            };
                          });
                        }}
                      >
                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.specificAccountExclusions === "Yes" ? (
                          <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                        ) : (
                          <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                        )}
                        YES
                      </label>

                      <label
                        style={{ marginBottom: "0px" }}
                        className={eclCss.stage2LeftCatgeorLabel}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => {
                            const old = prev[key] || {};
                            const oldValues = old.values || {};
                            return {
                              ...prev,
                              [key]: {
                                ...old,
                                values: {
                                  ...oldValues,
                                  specificAccountExclusions: "No",
                                },
                              },
                            };
                          });
                        }}
                      >
                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.specificAccountExclusions === "No" ? (
                          <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                        ) : (
                          <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                        )}
                        NO
                      </label>
                    </div>
                  </div>
                  
    
                   <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
                  >
                    <span className={eclCss.stage2labelSide}>
                      Do you want to add a further factor?
                    </span>
                    <div className={eclCss.stage2radioContainer}>
                      <label
                        style={{ marginRight: "20px", marginBottom: "0px" }}
                        className={eclCss.stage2LeftCatgeorLabel}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => {
                            const old = prev[key] || {};
                            const oldValues = old.values || {};
                            return {
                              ...prev,
                              [key]: {
                                ...old,
                                values: {
                                  ...oldValues,
                                  addFurtherFactor: "Yes",
                                },
                              },
                            };
                          });
                        }}
                      >
                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.addFurtherFactor === "Yes" ? (
                          <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                        ) : (
                          <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                        )}
                        YES
                      </label>

                      <label
                        style={{ marginBottom: "0px" }}
                        className={eclCss.stage2LeftCatgeorLabel}
                        onClick={() => {
                          const key = `${item.categoryID}_${item.subcategoryID}`;
                          setcategorysPDObj((prev) => {
                            const old = prev[key] || {};
                            const oldValues = old.values || {};
                            return {
                              ...prev,
                              [key]: {
                                ...old,
                                values: {
                                  ...oldValues,
                                  addFurtherFactor: "No",
                                },
                              },
                            };
                          });
                        }}
                      >
                        {categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.addFurtherFactor === "No" ? (
                          <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                        ) : (
                          <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                        )}
                        NO
                      </label>
                    </div>
                  </div>
                  
                  {categorysPDObj[
                    `${item.categoryID}_${item.subcategoryID}`
                  ]?.values?.addFurtherFactor === "Yes" && (
                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor} ${eclCss.mt15}`}
                  >
                    <div>
                      {/* METHOD SELECT */}
                      <div className={eclCss.stage2radioContainer}>
                        {/* MULTIPLY */}
                        <label
                          style={{ marginRight: "20px", marginBottom: "0px" }}
                          className={eclCss.stage2LeftCatgeorLabel}
                          onClick={() => {
                            const key = `${item.categoryID}_${item.subcategoryID}`;
                            setcategorysPDObj((prev) => {
                              const old = prev[key] || {};
                              const oldValues = old.values || {};
                              return {
                                ...prev,
                                [key]: {
                                  ...old,
                                  values: {
                                    ...oldValues,
                                    StageTwoFactor: {
                                      ...(oldValues.StageTwoFactor || {}),
                                      method: "multiply",
                                    },
                                  },
                                },
                              };
                            });
                          }}
                        >
                          {categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values?.StageTwoFactor?.method === "multiply" ? (
                            <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                          ) : (
                            <InactiveRadioBtn
                              className={eclCss.custuRadioBtn}
                            />
                          )}
                          MULTIPLY
                        </label>

                        {/* ADD */}
                        <label
                          style={{ marginBottom: "0px" }}
                          className={eclCss.stage2LeftCatgeorLabel}
                          onClick={() => {
                            const key = `${item.categoryID}_${item.subcategoryID}`;
                            setcategorysPDObj((prev) => {
                              const old = prev[key] || {};
                              const oldValues = old.values || {};
                              return {
                                ...prev,
                                [key]: {
                                  ...old,
                                  values: {
                                    ...oldValues,
                                    StageTwoFactor: {
                                      ...(oldValues.StageTwoFactor || {}),
                                      method: "add",
                                    },
                                  },
                                },
                              };
                            });
                          }}
                        >
                          {categorysPDObj[
                            `${item.categoryID}_${item.subcategoryID}`
                          ]?.values?.StageTwoFactor?.method === "add" ? (
                            <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                          ) : (
                            <InactiveRadioBtn
                              className={eclCss.custuRadioBtn}
                            />
                          )}
                          ADD
                        </label>
                      </div>

                      {/* INPUT SECTION */}
                      <div className={eclCss.mt15}>
                        <div className={eclCss.pdsInptsContainer2}>
                          <div className={eclCss.stage2labelSide}>
                            {categorysPDObj[
                              `${item.categoryID}_${item.subcategoryID}`
                            ]?.values?.StageTwoFactor?.method === "multiply"
                              ? "Multiply by"
                              : "Add by"}
                          </div>

                          <div
                            className={eclCss.custNumInptContainer}
                            style={{ marginLeft: "0px" }}
                          >
                            <div className={eclCss.custInptBox}>
                              <input
                                className={eclCss.custInpt}
                                type="text"
                                value={
                                  categorysPDObj[
                                    `${item.categoryID}_${item.subcategoryID}`
                                  ]?.values?.StageTwoFactor?.percentage || ""
                                }
                                onChange={(e) => {
                                  const key = `${item.categoryID}_${item.subcategoryID}`;
                                  setcategorysPDObj((prev) => {
                                    const old = prev[key] || {};
                                    const oldValues = old.values || {};
                                    return {
                                      ...prev,
                                      [key]: {
                                        ...old,
                                        values: {
                                          ...oldValues,
                                          StageTwoFactor: {
                                            ...(oldValues.StageTwoFactor || {}),
                                            percentage: e.target.value,
                                          },
                                        },
                                      },
                                    };
                                  });
                                }}
                              />
                            </div>
                            <div
                              className={eclCss.custInptIncDescContainerRitPer}
                            >
                              <div className={eclCss.custInptNumUpArrCont}>
                                <PercebtageIcn />
                              </div>
                            </div>
                          </div>

                          {/* INFO TEXT */}
                          <div className={eclCss.calCulationInfoAlrt2}>
                            <div>
                              <EclExcaclamater />
                            </div>
                            &nbsp;
                            <span className={eclCss.infoText}>
                               This factor will be appropriately added or multiplied to
                      the      ECL % computed based on your policy
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  )}

                  <div
                    className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
                  >
                    <textarea
                      className={eclCss.textareaInput}
                      placeholder="Enter Remarks ..."
                      rows={4}
                      value={
                        categorysPDObj[
                          `${item.categoryID}_${item.subcategoryID}`
                        ]?.values?.StageTwoFactor?.remarks || ""
                      }
                      onChange={(e) => {
                        const key = `${item.categoryID}_${item.subcategoryID}`;
                        const val = e.target.value;
                        setcategorysPDObj((prev) => {
                          const old = prev[key] || {};
                          const oldValues = old.values || {};
                          const oldFactor = oldValues.StageTwoFactor || {};
                          return {
                            ...prev,
                            [key]: {
                              ...old,
                              values: {
                                ...oldValues,
                                StageTwoFactor: {
                                  ...oldFactor,
                                  remarks: val, // remarks goes inside StageTwoFactor
                                },
                              },
                            },
                          };
                        });
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={eclCss.stage2CategorySaveBtnContainer}
              key={index}
              hidden
            >
              <button
                className={eclCss.categorySaveBtn}
                type="button"
                key={index}
              >
                Save
              </button>
            </div>
          </div>
          // : null
        ))}
      </div>
    </React.Fragment>
  );
};

const StageFive = ({
  categorysData,
  finallObjectData,
  reviewAndSubmitActiveTab,
  setreviewAndSubmitActiveTab,
}) => {
  return (
    <div className={`${eclCss.stage3Container} ${eclCss.custmfadein}`}>
      <div className={eclCss.StageOnecontainer}>
        <div className={eclCss.reviewContainerHeader}>Scenario Details</div>

        <div className={eclCss.reviewQuestionContainer}>
          <div className={eclCss.reviewQuestionLabel}>Scenario Name</div>
          <div className={eclCss.reviewQuestionAnswer}>
            {finallObjectData?.name}
          </div>
        </div>

        <div className={eclCss.reviewQuestionContainer}>
          <div className={eclCss.reviewQuestionLabel}>IndAS Provisioning</div>
          <div className={eclCss.reviewQuestionAnswer}>
            {finallObjectData?.indASProvisioning === "generalApproach"
              ? "General Approach"
              : "Simplified Approach"}
          </div>
        </div>
      </div>

      <div className={eclCss.reviewSubmitBody}>
        <div className={eclCss.reviewContainerHeader}>Policy Definition</div>

        <div className={eclCss.reviewQuestionContainer}>
          <div className={eclCss.reviewQuestionLabel}>Model</div>
          <div className={eclCss.reviewQuestionAnswer}>
            {finallObjectData?.model}
          </div>
        </div>

        <div className={eclCss.reviewQuestionContainer}>
          <div className={eclCss.reviewQuestionLabel}>
            Do you want categorization?
          </div>
          <div className={eclCss.reviewQuestionAnswer}>
            {finallObjectData?.categorize}
          </div>
        </div>

        {
          finallObjectData?.categorize === "Yes" ? (
            <React.Fragment>
              <div style={{ paddingTop: "10px" }}>
                <div className={eclCss.catgegoryContainer}>
                  {finallObjectData?.categorized?.map((item, index) => (
                    <div
                      key={index}
                      className={
                        reviewAndSubmitActiveTab === index
                          ? index === 0
                            ? eclCss.activeCategoryTab
                            : eclCss.activeCategoryTabNoRadius
                          : eclCss.inActiveCategoryTab
                      }
                      onClick={() => setreviewAndSubmitActiveTab(index)}
                    >
                      <div>
                        <div className={eclCss.WMaxContant}>
                          {item.category || `Category ${index + 1}`}
                        </div>
                        <small className={eclCss.smallTxt}>
                          {item.subcategory || "Subcategory"}
                        </small>
                      </div>
                    </div>
                  ))}
                </div>

                {finallObjectData?.categorized?.map((item, index) => (
                  <div
                    key={index}
                    className={`${eclCss.tabConrainerBorder} ${
                      reviewAndSubmitActiveTab === index
                        ? eclCss.containerShow
                        : eclCss.containerNone
                    }`}
                  >
                    <div className={eclCss.reviewQuestionContainer}>
                      <div className={eclCss.reviewQuestionLabel}>
                        Exclude from computation?
                      </div>
                      <div className={eclCss.reviewQuestionAnswer}>
                        {item.excludeFromComputation}
                      </div>
                    </div>

                    <div className={eclCss.reviewQuestionContainer}>
                      <div className={eclCss.reviewQuestionLabel}>Default</div>
                      <div className={eclCss.reviewQuestionAnswer}>
                        {item.values.defaultDays} days
                      </div>
                    </div>

                    <div className={eclCss.reviewQuestionContainerColum}>
                      <div className={eclCss.reviewQuestionLabel}>
                        Ageing Buckets
                      </div>
                      <div className={eclCss.reviewQuestionAnswerFill}>
                        {item.values.buckets.map((bucket, i) => (
                          <div key={i} className={eclCss.m15}>
                            {bucket.name} – {bucket.from}
                            {bucket.to ? ` to ${bucket.to}` : "+"} days
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className={eclCss.reviewQuestionContainer}>
                      <div className={eclCss.reviewQuestionLabel}>
                        Frequency for ECL Calculation
                      </div>
                      <div className={eclCss.reviewQuestionAnswer}>
                        {item.values.frequency}
                      </div>
                    </div>

                    <div className={eclCss.reviewQuestionContainer}>
                      <div className={eclCss.reviewQuestionLabel}>
                        How many periods to consider?
                      </div>
                      <div className={eclCss.reviewQuestionAnswer}>
                        {item.values.periods} years
                      </div>
                    </div>

                    <div className={eclCss.reviewQuestionContainer}>
                      <div className={eclCss.reviewQuestionLabel}>
                        {item.values.computationMethod === "weightedAverage"
                          ? "Weighted average percentage"
                          : "Simple average percentage"}
                      </div>
                      <div className={eclCss.reviewQuestionAnswer}>
                        {item.values.computationPercentage}%
                      </div>
                    </div>

                    <div className={eclCss.reviewQuestionContainer}>
                      <div className={eclCss.reviewQuestionLabel}>
                        Do you want to consider net credit customers?
                      </div>
                      <div className={eclCss.reviewQuestionAnswer}>
                        {item.values.netCreditCustomers}
                      </div>
                    </div>

                    <div className={eclCss.reviewQuestionContainer}>
                      <div className={eclCss.reviewQuestionLabel}>
                        Do you want specific account exclusions?
                      </div>
                      <div className={eclCss.reviewQuestionAnswer}>
                        {item.values.specificAccountExclusions}
                      </div>
                    </div>

                    {item.values.addFurtherFactor === "Yes" && (
                      <div className={eclCss.reviewQuestionContainer}>
                        <div className={eclCss.reviewQuestionLabel}>
                          Additional Factor –{" "}
                          {item.values.additionalFactor.method === "add"
                            ? "Add by"
                            : "Multiply by"}
                        </div>
                        <div className={eclCss.reviewQuestionAnswer}>
                          {item.values.additionalFactor.percentage}%
                        </div>
                      </div>
                    )}

                    <div className={eclCss.reviewQuestionContainer}>
                      <div className={eclCss.reviewQuestionLabel}>
                        Factor Remarks
                      </div>
                      <div className={eclCss.reviewQuestionAnswer}>
                        {item.values.additionalFactor.remarks}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </React.Fragment>
          ) : (
            // null
            <div style={{ paddingTop: "10px" }}>
              {/* <div className={eclCss.tabConrainerBorder}> */}
              <div className={eclCss.reviewQuestionContainer}>
                <div className={eclCss.reviewQuestionLabel}>Default</div>
                <div className={eclCss.reviewQuestionAnswer}>
                  {finallObjectData.global.defaultDays} days
                </div>
              </div>

              <div className={eclCss.reviewQuestionContainerColum}>
                <div className={eclCss.reviewQuestionLabel}>Ageing Buckets</div>
                <div className={eclCss.reviewQuestionAnswerFill}>
                  {finallObjectData.global.buckets.map((bucket, i) => (
                    <div key={i} className={eclCss.m15}>
                      {bucket.from}
                      {bucket.to ? ` to ${bucket.to} days` : ""}
                    </div>
                  ))}
                </div>
              </div>

              <div className={eclCss.reviewQuestionContainer}>
                <div className={eclCss.reviewQuestionLabel}>
                  Frequency for PD Calculation
                </div>
                <div className={eclCss.reviewQuestionAnswer}>
                  {finallObjectData.global.frequency}
                </div>
              </div>

              <div className={eclCss.reviewQuestionContainer}>
                <div className={eclCss.reviewQuestionLabel}>
                  How many periods to consider?
                </div>
                <div className={eclCss.reviewQuestionAnswer}>
                  {finallObjectData.global.periods} years
                </div>
              </div>

              <div className={eclCss.reviewQuestionContainer}>
                <div className={eclCss.reviewQuestionLabel}>
                  {finallObjectData.global.computationMethod ===
                  "weightedAverage"
                    ? "Weighted average percentage"
                    : "Simple average percentage"}
                </div>
                <div className={eclCss.reviewQuestionAnswer}>
                  {finallObjectData.global.computationPercentage}%
                </div>
              </div>

              <div className={eclCss.reviewQuestionContainer}>
                <div className={eclCss.reviewQuestionLabel}>
                  Do you want to consider net credit customers?
                </div>
                <div className={eclCss.reviewQuestionAnswer}>
                  {finallObjectData.global.netCreditCustomers}
                </div>
              </div>

              <div className={eclCss.reviewQuestionContainer}>
                <div className={eclCss.reviewQuestionLabel}>
                  Do you want specific account exclusions?
                </div>
                <div className={eclCss.reviewQuestionAnswer}>
                  {finallObjectData.global.specificAccountExclusions}
                </div>
              </div>

              {finallObjectData.global.addFurtherFactor === "Yes" && (
                <>
                  <div className={eclCss.reviewQuestionContainer}>
                    <div className={eclCss.reviewQuestionLabel}>
                      Additional Factor –{" "}
                      {finallObjectData.global.additionalFactor.method === "add"
                        ? "Add by"
                        : "Multiply by"}
                    </div>
                    <div className={eclCss.reviewQuestionAnswer}>
                      {finallObjectData.global.additionalFactor.percentage}%
                    </div>
                  </div>

                  <div className={eclCss.reviewQuestionContainer}>
                    <div className={eclCss.reviewQuestionLabel}>
                      Factor Remarks
                    </div>
                    <div className={eclCss.reviewQuestionAnswer}>
                      {finallObjectData.global.additionalFactor.remarks}
                    </div>
                  </div>
                </>
              )}
            </div>
          )

          // </div>
        }
      </div>
    </div>
  );
};

const EclHeader = ({
  createOrupdate,
  scenarioId,
  ActiveStage,
  setActiveStage,
  companyID,
  companyName,
  StageOneScenarioName,
}) => {
  const routerHistory = useHistory();
  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  const deleteScenario = async (scenarioId) => {
    await deleteReceivableECLScenario(scenarioId);
    handleClick("/myfinv2/receivables-policy/" + companyID);
  };

  const breadcrumbItems = [
    {
      label: "My companies",
      link: `/myfinV2/my-companies`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: companyName,
      link: `/myfinV2/company-details/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Accounting policy",
      link: `/myfinV2/accounting-policy/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Receivables",
      link: `/myfinV2/receivables-policy/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label:
        createOrupdate === "updateFlow"
          ? StageOneScenarioName
          : "Create Scenario",
      className: `${commoncss.nav_cnt_color}`,
    },
  ];

  return (
    <div className={eclCss.breadMainCumbContainer}>
      <Breadcrumb
        addCls="bgTransprent"
        items={breadcrumbItems}
        headerActions={<></>}
        p0={true}
      />

      <button
        className={` ${
          createOrupdate === "updateFlow"
            ? eclCss.unhideContant
            : eclCss.hiddeContant
        } ${eclCss.delBtn}`}
        onClick={() => {
          deleteScenario(scenarioId);
        }}
        type="button"
      >
        Delete
      </button>
    </div>
  );
};

// const StageNumberBadge = ({
//     ActiveStage,
//     setActiveStage,
//     }) => {

//         var outerBadge1 = ''
//         var innerBadge1 = ''
//         var badgeConnecter1 = ''
//         var content1 = 1

//         var outerBadge2 = ''
//         var innerBadge2 = ''
//         var badgeConnecter2 = ''
//         var content2 = 2

//         var outerBadge3 = ''
//         var innerBadge3 = ''
//         var badgeConnecter3 = ''
//         var content3 = 3

//         if (ActiveStage === 1) {
//                 outerBadge1 = `${eclCss.numBadge} ${eclCss.activeBadegClr}`;
//                 innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.activeBadgeBgClr}`
//                 content1 = 1

//                 outerBadge2 =  `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.inactiveBadgeBgClr}`
//                 content2 = 2

//                 outerBadge3 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.inactiveBadgeBgClr}`
//                 content3 = 3

//             }
//             else if (ActiveStage === 2 || ActiveStage === 'C2') {
//                 outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`;
//                 innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.completedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${eclCss.numBadge} ${eclCss.activeBadegClr}`
//                 innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.activeBadgeBgClr}`

//                 outerBadge3 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.inactiveBadgeBgClr}`

//             }
//             else if (ActiveStage === 3 || ActiveStage === 'C3') {
//                 outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`;
//                 innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${eclCss.numBadge} ${eclCss.completeBadgeClr}`
//                 innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.completedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${eclCss.numBadge} ${eclCss.activeBadegClr}`
//                 innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.activeBadgeBgClr}`
//             }

//     return (

//         <div className={eclCss.numBadgeMainContainer}>
//             <div className={eclCss.numberContainer}>
//                 <div onClick={ () => {} } key={1} className={outerBadge1}>
//                     <div className={badgeConnecter1}></div>
//                     <div className={innerBadge1}>{content1}</div>
//                     <div className={`${eclCss.numberText} ${eclCss.numberText1}`}>SCENARIO INFO</div>
//                 </div>
//                 <div onClick={ () => {} } key={2} className={outerBadge2}>
//                     <div className={badgeConnecter2}></div>
//                     <div className={innerBadge2}>{content2}</div>
//                     <div className={`${eclCss.numberText} ${eclCss.numberText2}`}>DEFINE PD</div>
//                 </div>
//                 <div onClick={ () => {} } key={3} className={outerBadge3}>
//                     <div className={badgeConnecter3}></div>
//                     <div className={innerBadge3}>{content3}</div>
//                     <div className={`${eclCss.numberText} ${eclCss.numberText3}`}>DEFINE LGD</div>
//                 </div>
//             </div>
//         </div>
//     );
// };

const StageNumberBadge = ({ ActiveStage, setActiveStage }) => {
  var outerBadge1 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr} ${eclCss.badge}`;
  var innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
  var badgeConnecter1 = `${eclCss.numbConnterStart2} ${eclCss.inactiveBadgeBgClr}`;
  var content1 = 1;

  var outerBadge2 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr} ${eclCss.badge}`;
  var innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
  var badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.inactiveBadgeBgClr}`;
  var content2 = 2;

  var outerBadge3 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr} ${eclCss.badge}`;
  var innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
  var badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.inactiveBadgeBgClr}`;
  var content3 = 3;

  if (ActiveStage === 1) {
    outerBadge1 = `${eclCss.numBadge} ${eclCss.activeBadegClr} ${eclCss.badge}`;
    innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
    badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.activeBadgeBgClr}`;
    content1 = 1;
  } else if (ActiveStage === 2 || ActiveStage === "C2") {
    outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
    innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
    badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.completedBadgConnecterClr}`;
    content1 = <CompleteECLIcon />;

    outerBadge2 = `${eclCss.numBadge} ${eclCss.activeBadegClr} ${eclCss.badge}`;
    innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
    badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.middleActiveBar} `;

    badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.lastInActiverBar} `;
  } else if (ActiveStage === 3) {
    outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
    innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
    badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.fullCompletedBadgConnecterClr} `;
    content1 = <CompleteECLIcon />;

    outerBadge2 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
    innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
    badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.fullCompletedBadgConnecterClr} `;
    content2 = <CompleteECLIcon />;

    outerBadge3 = `${eclCss.numBadge} ${eclCss.activeBadegClr} ${eclCss.badge}`;
    innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
    badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.lastConnecter} `;
  }

  return (
    <div className={eclCss.numBadgeMainContainer}>
      <div className={eclCss.numberContainer}>
        <div
          onClick={() => {}}
          key={1}
          className={`${eclCss.numBadgeContainer} ${eclCss.badgeContainerOne}`}
        >
          <div className={badgeConnecter1}></div>
          <div className={`${outerBadge1} ${eclCss.badge}`}>
            <div className={innerBadge1}>{content1}</div>
          </div>
          <div className={`${eclCss.numberText} ${eclCss.numberText1}`}>
            Scenario info
          </div>
        </div>
        <div
          onClick={() => {}}
          key={2}
          className={`${eclCss.numBadgeContainer} ${eclCss.badgeContainerTwo}`}
        >
          <div className={badgeConnecter2}></div>
          <div className={`${outerBadge2} ${eclCss.badge}`}>
            <div className={innerBadge2}>{content2}</div>
          </div>
          <div className={`${eclCss.numberText} ${eclCss.numberText2}`}>
            define policy
          </div>
        </div>
        <div
          onClick={() => {}}
          key={3}
          className={`${eclCss.numBadgeContainer} ${eclCss.badgeContainerThree}`}
        >
          <div className={badgeConnecter3}></div>
          <div className={`${outerBadge3} ${eclCss.badge}`}>
            <div className={innerBadge3}>{content3}</div>
          </div>
          <div className={`${eclCss.numberText} ${eclCss.numberText3}`}>
            review and submit
          </div>
        </div>
      </div>
    </div>
  );
};

// const buildCategoryBucketsPayload = (buckets) => {
//   const normal = buckets.filter(b => b.to !== "");
//   const last = normal[normal.length - 1];

//   return [
//     ...normal,
//     last?.to
//       ? { name: `${Number(last.to) + 1}+`, from: Number(last.to) + 1 }
//       : null,
//   ].filter(Boolean);
// };

const buildCategoryBucketsPayload = (buckets = []) => {
  const normalBuckets = buckets
    .filter(b => b.to !== undefined && b.to !== "")
    .map((b, index) => ({
      name: index === 0 ? `0-${b.to}` : `${b.from}-${b.to}`,
      from: Number(b.from),
      to: Number(b.to),
    }));

  const lastBucket = normalBuckets[normalBuckets.length - 1];
  
  if (lastBucket && lastBucket.to !== undefined) {
    return [
      ...normalBuckets,
      {
        name: `${lastBucket.to + 1}+`,
        from: lastBucket.to + 1,
      }
    ];
  }

  return normalBuckets;
};


const EclFooter = ({
  createOrupdate,
  scenarioId,
  StageTwoCategorization,
  companyID,
  ActiveStage,
  setActiveStage,
  stageOneWholeData,
  stageTwoWholeData,
  stageTwoCategoryWholeData,
  finallObjectData,
  setfinallObjectData,
  setShowScenarioNameError,
}) => {
  const routerHistory = useHistory();
  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  const formateData = (sendDataToApi) => {
    const categorized = [];
    const categoryData = Object.values(stageTwoCategoryWholeData);

    for (let i = 0; i < categoryData.length; i++) {
      const item = categoryData[i];

      const buckets = [...(item.values?.buckets || [])];

      const finalBucketTo = item.values?.StageTwoFinalBucketTo;
      if (finalBucketTo) {
        buckets.push({
          name: finalBucketTo + "+",
          from: Number(finalBucketTo),
        });
      }

      const obj = {
        categoryID: item.categoryID,
        subcategoryID: item.subcategoryID,
        excludeFromComputation: item.values?.excludeFromComputation || "No",
        values: {
          defaultDays: item.values?.defaultDays || 0,
          bucketOneNotDue: "No",
          buckets: buildCategoryBucketsPayload(item.values?.buckets),
          StageTwoFinalBucketTo: item.values?.StageTwoFinalBucketTo,
          frequency: item.values?.frequency || "monthly",
          periods: item.values?.percentage,
          computationMethod: item.values?.StageTwoCategorySAWApE,
          computationPercentage: item.values?.computationPercentage || 0,
          netCreditCustomers: item.values?.netCreditCustomers || "No",
          specificAccountExclusions:
            item.values?.specificAccountExclusions || "No",
          addFurtherFactor: item.values?.addFurtherFactor || "No",
        },
      };

      if (item.values?.addFurtherFactor === "Yes") {
        obj.values.additionalFactor = item.values?.StageTwoFactor;
      }

      categorized.push(obj);
    }

    const finallObj = {
      name: stageOneWholeData.name,
      companyID: companyID,
      provisioningApproach: stageOneWholeData.provisioningApproach,
      model: stageTwoWholeData.model,
      categorize: stageTwoWholeData.categorize,
      global: stageTwoWholeData.global,
      categorized: categorized,
    };

    if (stageTwoWholeData?.categorize === "Yes") {
      delete finallObj.global;

      const cateObj = finallObj?.categorized || [];

      for (let i = 0; i < cateObj.length; i++) {
        const entry = cateObj[i];
        const values = entry.values || {};
        const buckets = values.buckets || [];
         
        for (let j = 0; j < buckets.length; j++) {
          const b = buckets[j];

          if (b.to !== undefined) {
            b.name = `${b.from}-${b.to}`;
          }
        }
 
         if (
          values.StageTwoFinalBucketTo === undefined ||
          values.StageTwoFinalBucketTo === "" ||
          values.StageTwoFinalBucketTo === null
          ) { buckets.push({
            from: Number(values.StageTwoFinalBucketTo),
            name: `${values.StageTwoFinalBucketTo}+`,
          });      
        }
        delete values.StageTwoFinalBucketTo;
        values.buckets = buckets;
      }

      console.log("finallObj YES cate :: ", finallObj.categorized);

      let categoryLst = finallObj.categorized;

      for (let index = 0; index < categoryLst?.length; index++) {
        const element = categoryLst[index];

        let bucketLst = element.values.buckets;

        for (let index = 0; index < bucketLst.length; index++) {
          const element = bucketLst[index];
          delete element?._id;
        }
      }
     } else {
      let finalBucketVal = finallObj.global?.StageTwoFinalBucket;

      const hasFinalBucket = finallObj.global.buckets.some(
        b => b.to === undefined && b.from !== undefined
      );

      if (!hasFinalBucket && finalBucketVal) {
        let finalBucketItm = {
          name: finalBucketVal + "+",
          from: Number(finalBucketVal),
        };
        finallObj.global.buckets = [
          ...(finallObj.global?.buckets || []),
          finalBucketItm,
        ];
      }

      delete finallObj.global?.StageTwoFinalBucket;
      delete finallObj?.categorized;
}

    if (finallObj.global?.addFurtherFactor === "No") {
      delete finallObj.global?.additionalFactor;
      finallObj.global.addFurtherFactor = "No";
    } else if (finallObj.global?.addFurtherFactor === "Yes") {
      const percentage = finallObj.global?.additionalFactor?.percentage;
      if (!percentage || percentage === "" || isNaN(Number(percentage))) {
        delete finallObj.global?.additionalFactor;

        finallObj.global.addFurtherFactor = "No";
      }
    }

    if (sendDataToApi) {
      if (createOrupdate === "updateFlow") {
        updateReceivablesECLScenario(scenarioId, finallObj)
          .then((response) => {
            toast.success("Scenario Updated Successfully.");
            handleClick("/myfinv2/receivables-policy/" + companyID);
          })
          .catch((error) => {
            swal(
              "Error",
              error.response?.data?.error || "Saving Upldate scenario!",
              "error"
            );
          });
      }

      if (createOrupdate === "createFlow") {
        createNewEclScenarioReceivable(finallObj)
          .then((response) => {
            toast.success("New Scenario Created Successfully.");

            const newScenarioId =
              response?.data?._id || response?.data?.scenarioId;

            if (newScenarioId) {
              handleClick(
                `/myfinv2/receivables-policy/${companyID}?newScenario=${newScenarioId}`
              );
            } else {
              handleClick(`/myfinv2/receivables-policy/${companyID}`);
            }
          })

          .catch((error) => {
            swal(
              "Error",
              error.response?.data?.error || "Saving new scenario!",
              "error"
            );
          });
      }
    } else {
      setfinallObjectData(finallObj);
    }
  };

  return (
    <div className={`${eclCss.footerContainer} ${eclCss.custmfadein}`}>
      <div>
        <button
          onClick={() => {
            handleClick("/myfinv2/receivables-policy/" + companyID);
          }}
          className={eclCss.cancelBtn}
          type="button"
        >
          Cancel
        </button>
      </div>
      <div className={eclCss.footerbtnContainer}>
        <button
          onClick={() => {
            if (ActiveStage === "C2" || ActiveStage === 2) {
              setActiveStage(1);
            } else if (ActiveStage === "C3" || ActiveStage === 3) {
              if (StageTwoCategorization === "Yes") {
                setActiveStage("C2");
              } else {
                setActiveStage(2);
              }
            }
          }}
        type="button"
        disabled={ActiveStage === 1}
        style={{
          opacity: ActiveStage === 1 ? 0.4 : 1,
        }}
        className={eclCss.perviewBtn}
      >
          <PervBtnIcon /> Previous
        </button>

        <button
          onClick={() => {
            if (ActiveStage === 1) {
              if (
                !stageOneWholeData.name ||
                stageOneWholeData.name.trim() === ""
              ) {
                setShowScenarioNameError(true);
                return;
              }
              if (StageTwoCategorization === "Yes") {
                setActiveStage("C2");
              } else {
                setActiveStage(2);
              }
            } else if (ActiveStage === "C2" || ActiveStage === 2) {
              setActiveStage(3);
              formateData(false);
            } else if (ActiveStage === "C3" || ActiveStage === 3) {
              formateData(true);
            }
          }}
          className={eclCss.saveBtn}
          type="button"
        >
          {ActiveStage === 3
            ? createOrupdate === "updateFlow"
              ? "Update Scenario"
              : "Create Scenario"
            : "Next"}
        </button>
      </div>
    </div>
  );
};

// export const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     borderColor: '#c2e6d1',
//     color: '#b3c0bd',
//     boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
//     borderWidth: '1px',
//     borderRadius: '10px',
//     '&:hover': {
//       borderColor: '#b3c0bd',
//     },
//     minHeight: '38px',
//     height: '38px'
//   }),
//   valueContainer: (provided) => ({
//     ...provided,
//     padding: '2px 8px',
//     paddingTop: '1px'
//   }),
//   input: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     fontSize: "14px"
//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//     fontSize: "14px"
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: '#e0f5e9', // softer variant
//     borderRadius: '0.25rem',
//     border: '1px solid #c2e6d1',
//     width: 'fit-content'
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       backgroundColor: '#c2e6d1',
//       color: '#4f665f',
//     },
//   }),
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     border: '1px solid #c2e6d1',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
//     borderRadius: '0.5rem',
//     zIndex: 10,
//   }),
//   menuList: (provided) => ({
//     ...provided,
//     padding: 0,
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//         ? '#e9f7ef'
//         : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: "14px"
//   }),
//   noOptionsMessage: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     padding: '8px 12px',
//   }),
// };

export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#f4faf5",
    borderColor: "#c2e6d1",
    color: "#b3c0bd",
    boxShadow: state.isFocused ? "0 0 0 1px #c2e6d1" : "none",
    borderWidth: "1px",
    borderRadius: "10px",
    "&:hover": {
      borderColor: "#b3c0bd",
    },
    textColor: "#205a46",
    minHeight: "38px",
    height: "38px",
    zIndex: "9999",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 8px",
    paddingTop: "1px",
  }),
  input: (provided) => ({
    ...provided,
    color: "#b3c0bd",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    fontSize: "14px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#4d6d64",
    fontSize: "14px",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e0f5e9",
    borderRadius: "0.25rem",
    border: "1px solid #c2e6d1",
    width: "fit-content",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#4d6d64",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    ":hover": {
      backgroundColor: "#c2e6d1",
      color: "#4f665f",
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: "#b3c0bd",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#205a46",
    ":hover": {
      color: "#205a46",
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    ":hover": {
      color: "#4f665f",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#ffffff",
    border: "1px solid #c2e6d1",
    borderRadius: "10px",
    boxShadow: "0 0 0 1px #c2e6d1",
    marginTop: "6px",
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "4px",
    borderRadius: "10px",
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f4faf5" : "transparent",
    color: "#4f665f",
    padding: "10px 12px",
    cursor: "pointer",
    fontSize: "14px",
    borderRadius: "8px",
  }),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    padding: "8px 12px",
  }),
};